import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { NewVulnerabilityService } from "../Data Service/new-vulnerability.service";
import { IVul } from "./IVul";
import { IContract } from "./IContract";
import { AppComponent } from "../app.component";
import * as moment from "moment";
import { VulUserView } from "../Data Service/VulUserView";
import { IUpdateContract } from "./UpdateCon";
import { getLocaleDateFormat } from "@angular/common";
import { NgxSpinnerService } from "ngx-spinner";
import { DateRange, DefaultMatCalendarRangeStrategy } from "@angular/material/datepicker";
import { ClientApplication } from "@azure/msal-browser/dist/app/ClientApplication";
import { Observable, Subject } from "rxjs";
import { concatMapTo, delay, map,mergeMap,startWith} from "rxjs/operators";
import { ConfirmDialogModel, DialogueConfirmationComponent } from "../Dialogue Confirmation/dialogue-confirmation/dialogue-confirmation.component";
import { MatDialog } from "@angular/material/dialog";
import { ComplexOuterSubscriber } from "rxjs/internal/innerSubscribe";
import{Delegate}from "./Delegate"
import { IContractData } from "./IContractData";
import { data } from "jquery";

interface Website {
  id: string;
  name: string;
}
@Component({
  selector: "app-user-view-vulnerability",
  templateUrl: "./user-view-vulnerability.component.html",
  styleUrls: ["./user-view-vulnerability.component.css"]
})

export class UserViewVulnerabilityComponent implements OnInit {  
  productForm: UntypedFormGroup;  
  public errorMessage: string = "";
  UserName  :IVul[];  
  objVulUserView : VulUserView;
  disableSelect: boolean;
  cart: any = [];
  Eid : string = "";
  DateConv:string="";
  UserFormData : any[];
  idAttr : any;
  isExpanded = false;
  Hidebtn = false;
  indexExpanded: number = -1;  
  contArrLength : number = 0;
  grCount : number = 0;
  contFill : number = 0;
  contData : any;
  overAllGrCnt : number = 0;
  grFlag : boolean = false;
  ConValPrevData : Array<IUpdateContract> =[];
  EmailData:any;
  myControl = new UntypedFormControl('');
 options: string[] = [];
 filteredOptions: Observable<string[]>;
 PeoplePicker: any;
 ObjDelClass=new Delegate(); 
 selectDel : Array<any> =[];
 contractnumber = new UntypedFormControl(['']);
 currentindex:any;
 protected _onDestroy = new Subject();
  DDdata: any;
  result: string = '';
tempClient : string = '';
num : number = 0;
ContData : any;
chkLength : number = 0;
selectDelName : Array<any> = [];
appliedColor = '';
toShow : boolean = false;
grCheckCount : number = 0;
grCheckFlag : boolean = false;
delDisable : boolean = true;
selectedValue : any;
flgCount : number =0;
static flgCnt : number = 0;
flagDelegate : number = 0;
delegateColor = '';
fillColorFlag : number = 0;
delFlag : boolean = true;
ActualDelSelCheck : number = 0;
ContPrevData : Array<IUpdateContract> =[];

  constructor(public dialog: MatDialog,private spinner: NgxSpinnerService,private service : NewVulnerabilityService,private router: Router,private fb:UntypedFormBuilder,private appComponent :AppComponent,private _router : Router,private cdRef: ChangeDetectorRef ) 
  { 
    this.productForm = this.fb.group({
      Filter_Status:"",
      Filter_DueDate:"",
      quantities: this.fb.array([]),                     
    })
     this.Eid = localStorage.getItem('UserID').substring(0,localStorage.getItem('UserID').lastIndexOf("@"));      
      // this.Eid = "sharad.singh.singh";
    // this.productForm.get('Filter_Status').valueChanges.subscribe(value => { "It has finally changed"+value })
  }

  
  confirmDialog(event:any,IsDelegated:any): void {
    const message = `Are you sure you want to do save?`;

    const dialogData = new ConfirmDialogModel("Confirm Action", message);

    const dialogRef = this.dialog.open(DialogueConfirmationComponent, {
      maxWidth: "400px",
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      this.result = dialogResult;     
      
      if(dialogResult)
      {
        this.onSubmit(event,IsDelegated)
      }    

    });
  }

  togglePanels(index: number) {
    this.currentindex=index;
    this.flgCount = 0;
    UserViewVulnerabilityComponent.flgCnt = 0;
    if (this.indexExpanded != index) {
      this.grCount = 0;
      this.contFill=0;
    }
    //this.indexExpanded = index == this.indexExpanded ? -1 : index;
    this.indexExpanded = index;
    console.log(this.quantities().controls[index].get("status").value);
    if(this.Eid != this.quantities().controls[index].get("LastUpdatedBy").value && this.quantities().controls[index].get("status").value=="Complete"){      
      this.Hidebtn = true;
    }
    else{
      this.Hidebtn=false;
    }
    console.log("cont arr");
    //console.log(this.quantities().controls[index].get("contracts_array").value.length);
    console.log("vid : ");
    console.log(this.quantities().controls[index].get("VID").value)
    // this.InitialArray();
    var FilterData = {
      UserID : this.Eid,   
      VID :   this.quantities().controls[index].get("VID").value    
  }
  // if (this.contFill == 0){
  //   this.setUserContractData(FilterData);
  //   if(this.quantities().controls[index].get("contracts_array").value == null){
  //     this.setUserContractData(FilterData);
  //   }
  //   //this.contArrLength = this.quantities().controls[index].get("contracts_array").value.length;
  // }
  this.contArrLength = this.quantities().controls[index].get("contracts_array").value.length -1;
    //console.log(this.contractsmethod(index).controls[0].get("DoAccManage").value);
    //console.log(this.contractsmethod(index).controls[1].get("DoAccManage").value);
    let ConVal : Array<IUpdateContract> =[];
    
    
      for (let j=0; j < this.quantities().controls[index].get("contracts_array").value.length; j++){
        var ConValdata = new IUpdateContract();
        
          ConValdata.contract = this.contractsmethod(index).controls[j].get("contract").value;
          ConValdata.remediationraised = this.contractsmethod(index).controls[j].get("remediationraised").value;
          //ConValdata.DoAccManage = this.contractsmethod(index).controls[j].get("DoAccManage").value;
          ConValdata.DoAccManage =  (this.contractsmethod(index).controls[j].get("DoAccManage").value == null) ? null : this.contractsmethod(index).controls[j].get("DoAccManage").value;
          ConValdata.ImpactedVersion = this.contractsmethod(index).controls[j].get("ImpactedVersion").value;
          ConValdata.AppliedCorrAction = this.contractsmethod(index).controls[j].get("AppliedCorrAction").value;
          ConValdata.ClientAppExcep = this.contractsmethod(index).controls[j].get("ClientAppExcep").value;
          // ConValdata.ClientInf = this.contractsmethod(index).controls[j].get("ClientInf").value;
          ConValdata.ClientImp = this.contractsmethod(index).controls[j].get("ClientImp").value;
          ConValdata.CommentAct = this.contractsmethod(index).controls[j].get("CommentAct").value;
          ConValdata.MitigationComment = this.contractsmethod(index).controls[j].get("MitigationComment").value;
          ConValdata.ContractVulStatus = "";
          ConValdata.FlagDelegate = this.contractsmethod(index).controls[j].get("FlagDelegate").value;

          this.flagDelegate = ConValdata.FlagDelegate;

          ConVal.push(ConValdata);
          this.ConValPrevData.push(ConValdata);
          this.ContPrevData.push(ConValdata);
          console.log("Tog Prev Data ");
          console.log(this.ContPrevData);

          //   var ConVal =[{
          //     contract:this.contractsmethod(index).controls[j].get("contract").value,                    
          //     remediationraised: this.contractsmethod(index).controls[j].get("remediationraised").value,
          //     DoAccManage  : this.contractsmethod(index).controls[j].get("DoAccManage").value,
          //     AppliedCorrAction : this.contractsmethod(index).controls[j].get("AppliedCorrAction").value,
          //     ClientAppExcep : this.contractsmethod(index).controls[j].get("ClientAppExcep").value,
          //     ClientInf : this.contractsmethod(index).controls[j].get("ClientInf").value,
          //     ClientImp : this.contractsmethod(index).controls[j].get("ClientImp").value
          //     //CommentAct : this.contractsmethod(index).controls[j].get("CommentAct").value
          // }]
          console.log("conval : ");
          console.log(ConVal.length);

        //if (this.contractsmethod(index).controls[j].get("client").value != "Template") {

          if ((ConVal[j].DoAccManage != "" || ConVal[j].ImpactedVersion != "" || ConVal[j].AppliedCorrAction != "" || ConVal[j].remediationraised != "" ||
            ConVal[j].ClientAppExcep != "" || ConVal[j].ClientInf != "" || ConVal[j].ClientImp != "")
            && (ConVal[j].DoAccManage != null || ConVal[j].ImpactedVersion != null || ConVal[j].AppliedCorrAction != null || ConVal[j].remediationraised != null ||
              ConVal[j].ClientAppExcep != null || 
              // ConVal[j].ClientInf != null || 
              ConVal[j].ClientImp != null)) {
            console.log("in toggle call ");
            console.log(index);
            console.log(j);
            console.log(ConVal[j].AppliedCorrAction)
            this.changecommaction("DoAccManage" + index + j, ConVal[j].DoAccManage);
            this.changecommaction("ImpactedVersion" + index + j, ConVal[j].ImpactedVersion);
            this.changecommaction("AppliedCorrAction" + index + j, ConVal[j].AppliedCorrAction);
            this.changecommaction("remediationraised" + index + j, ConVal[j].remediationraised);
            this.changecommaction("ClientAppExcep" + index + j, ConVal[j].ClientAppExcep);
            // this.changecommaction("ClientInf" + index + j, ConVal[j].ClientInf);
            this.changecommaction("ClientImp" + index + j, ConVal[j].ClientImp);
          }
          //this.changecommaction(index,j);
        //}
      }


      console.log("VID toggle : "+ this.quantities().controls[index].get("VID").value);
      console.log(this.quantities().controls[index].get("contracts_array"));

      let ContractVal : Array<IContractData> =[];
    
    
      for (let j=0; j < this.quantities().controls[index].get("contracts_array").value.length; j++){
        var ConValdataval = new IContractData();
        
         if (this.contractsmethod(index).controls[j].get("client").value != "Template"){
          ConValdataval.contract = this.contractsmethod(index).controls[j].get("contract").value;
          ConValdataval.contract_name = this.contractsmethod(index).controls[j].get("contract_name").value;
        ConValdataval.remediationraised = this.contractsmethod(index).controls[j].get("remediationraised").value;
          //ConValdata.DoAccManage = this.contractsmethod(index).controls[j].get("DoAccManage").value;
          ConValdataval.DoAccManage =  (this.contractsmethod(index).controls[j].get("DoAccManage").value == null) ? null : this.contractsmethod(index).controls[j].get("DoAccManage").value;
          ConValdataval.ImpactedVersion = this.contractsmethod(index).controls[j].get("ImpactedVersion").value;
          ConValdataval.AppliedCorrAction = this.contractsmethod(index).controls[j].get("AppliedCorrAction").value;
          ConValdataval.ClientAppExcep = this.contractsmethod(index).controls[j].get("ClientAppExcep").value;
          // ConValdataval.ClientInf = this.contractsmethod(index).controls[j].get("ClientInf").value;
          ConValdataval.ClientImp = this.contractsmethod(index).controls[j].get("ClientImp").value;
          ConValdataval.CommentAct = this.contractsmethod(index).controls[j].get("CommentAct").value;
          ConValdataval.MitigationComment = this.contractsmethod(index).controls[j].get("MitigationComment").value;
          ConValdataval.ContractVulStatus = "";

          ContractVal.push(ConValdataval);
         }
        
        }

      var FilterData2 = {
        UserID : this.Eid,   
        VID :   this.quantities().controls[index].get("VID").value,
        Index:index,
      ContractDDList:ContractVal, //this.quantities().controls[index].get("contracts_array").value,
      DelegateDDSelected:this.quantities().controls[index].get("Delegate_array").value   
    }

    // this.contractsmethod(this.indexExpanded).controls[0]
    //       .patchValue({
    //         tempDoAccManage: "No",
    //         tempImpactedVersion : null,
    //         tempRemediationDate : null,
    //         tempClientAppExcep:null,
    //         tempAppliedCorrAction:null,
    //         tempClientInf:null,
    //         tempClientImp:null,
    //         tempMitigationCommentOuter : "testing"
    //       })

          //this.quantities().controls[index].patchValue({tempDoAccManage : "No"})
      this.getNewDelegateDD(FilterData2);

      if(this.quantities().controls[index].get("UrlList").value.length > 0){
        this.toShow = true;
      }
      
      this.contractsmethod(index).controls[0].get('chkList').disable();

      if(this.Hidebtn){
        for (let j=0; j < this.quantities().controls[index].get("contracts_array").value.length; j++){
          this.contractsmethod(this.indexExpanded).controls[j].get('DoAccManage').disable();
          this.contractsmethod(this.indexExpanded).controls[j].get('ImpactedVersion').disable();
          this.contractsmethod(this.indexExpanded).controls[j].get('AppliedCorrAction').disable();
          this.contractsmethod(this.indexExpanded).controls[j].get('ClientAppExcep').disable();
          // this.contractsmethod(this.indexExpanded).controls[j].get('ClientInf').disable();
          this.contractsmethod(this.indexExpanded).controls[j].get('ClientImp').disable();
          this.contractsmethod(this.indexExpanded).controls[j].get('MitigationComment').disable();
          this.contractsmethod(this.indexExpanded).controls[j].get('chkList').disable();
        }
      }

      this.ActualDelSelCheck = this.quantities().controls[index].get("Delegate_array").value.length;
      console.log("Delegate selected data :"+this.ActualDelSelCheck);
}

checkFlagDelegateVal(rowNum : number,indexNum : number){
  // console.log("indexNum : "+indexNum);
  // console.log("rowNum : "+rowNum);
  try{
    // console.log("value : "+this.contractsmethod(rowNum).controls[indexNum].get("FlagDelegate"));
  return this.contractsmethod(rowNum).controls[indexNum].get("FlagDelegate").value
  }
  catch (err) {
    
    console.log("in error");
    console.log(err);
    return false;
  }
  
}

onChecklistChange(checked : any, i : any, j : any) {
  console.log("checked : " + checked);
  console.log("i j : "+ i +" "+ j);

  let ConVal : Array<IUpdateContract> =[];
  UserViewVulnerabilityComponent.flgCnt = 0;
  if(j==0){
    if(!checked)
    this.grCount = 0;
    for (let k = 0; k < this.quantities().controls[i].get("contracts_array").value.length; k++) {
      this.contractsmethod(i).controls[k]
          .patchValue({
            chkList : checked
          })

      if (k != 0 && checked) {
        
        this.contractsmethod(i).controls[k]
          .patchValue({
            DoAccManage: this.contractsmethod(i).controls[0].get("DoAccManage").value,
            ImpactedVersion: this.contractsmethod(i).controls[0].get("ImpactedVersion").value,
            AppliedCorrAction: this.contractsmethod(i).controls[0].get("AppliedCorrAction").value,
            remediationraised: this.contractsmethod(i).controls[0].get("remediationraised").value,
            ClientAppExcep: this.contractsmethod(i).controls[0].get("ClientAppExcep").value,
            // ClientInf: this.contractsmethod(i).controls[0].get("ClientInf").value,
            ClientImp: this.contractsmethod(i).controls[0].get("ClientImp").value,
            MitigationComment: this.contractsmethod(i).controls[0].get("MitigationComment").value
          })

/*
          if(this.contractsmethod(i).controls[j].get('ImpactedVersion').disabled){
            this.contractsmethod(i).controls[k].get('ImpactedVersion').disable();
          }

          if(this.contractsmethod(i).controls[j].get('AppliedCorrAction').disabled){
            this.contractsmethod(i).controls[k].get('AppliedCorrAction').disable();
          }

          if(this.contractsmethod(i).controls[j].get('remediationraised').disabled){
            this.contractsmethod(i).controls[k].get('remediationraised').disable();
          }

          if(this.contractsmethod(i).controls[j].get('ClientAppExcep').disabled){
            this.contractsmethod(i).controls[k].get('ClientAppExcep').disable();
          }

          if(this.contractsmethod(i).controls[j].get('ClientInf').disabled){
            this.contractsmethod(i).controls[k].get('ClientInf').disable();
          }

          if(this.contractsmethod(i).controls[j].get('ClientImp').disabled){
            this.contractsmethod(i).controls[k].get('ClientImp').disable();
          }
          **/
      }
      else if (k != 0 && !checked) {
        this.contractsmethod(i).controls[j]
          .patchValue({
            DoAccManage: null,
            ImpactedVersion: null,
            AppliedCorrAction: null,
            remediationraised: null,
            ClientAppExcep: null,
            // ClientInf: null,
            ClientImp: null,
            MitigationComment: null
          })
      }
          
    }
  }
  else{
    this.contractsmethod(i).controls[j]
          .patchValue({
            chkList : checked
          });

    if (checked) {

      let ContValCheck: Array<IContractData> = [];


      for (let jk = 0; jk < this.quantities().controls[i].get("contracts_array").value.length; jk++) {
        var ConValdataChk = new IContractData();

        if (this.contractsmethod(i).controls[jk].get("client").value == "Template") {
          // ConValdataChk.contract = this.contractsmethod(i).controls[jk].get("contract").value;
          // ConValdataChk.contract_name = this.contractsmethod(i).controls[jk].get("contract_name").value;
          ConValdataChk.remediationraised = this.contractsmethod(i).controls[jk].get("remediationraised").value;
          //ConValdata.DoAccManage = this.contractsmethod(index).controls[j].get("DoAccManage").value;
          ConValdataChk.DoAccManage = (this.contractsmethod(i).controls[jk].get("DoAccManage").value == null) ? null : this.contractsmethod(i).controls[jk].get("DoAccManage").value;
          ConValdataChk.ImpactedVersion = this.contractsmethod(i).controls[jk].get("ImpactedVersion").value;
          ConValdataChk.AppliedCorrAction = this.contractsmethod(i).controls[jk].get("AppliedCorrAction").value;
          ConValdataChk.ClientAppExcep = this.contractsmethod(i).controls[jk].get("ClientAppExcep").value;
          // ConValdataChk.ClientInf = this.contractsmethod(i).controls[jk].get("ClientInf").value;
          ConValdataChk.ClientImp = this.contractsmethod(i).controls[jk].get("ClientImp").value;
          ConValdataChk.MitigationComment = this.contractsmethod(i).controls[jk].get("MitigationComment").value;

          ContValCheck.push(ConValdataChk);
        }

      }

      if((ContValCheck[0].DoAccManage != null || ContValCheck[0].DoAccManage != "") || (ContValCheck[0].ClientInf != null || ContValCheck[0].ClientInf != ""))
      {
        this.contractsmethod(i).controls[j]
        .patchValue({
          DoAccManage: this.contractsmethod(i).controls[0].get("DoAccManage").value,
          ImpactedVersion: this.contractsmethod(i).controls[0].get("ImpactedVersion").value,
          AppliedCorrAction: this.contractsmethod(i).controls[0].get("AppliedCorrAction").value,
          remediationraised: this.contractsmethod(i).controls[0].get("remediationraised").value,
          ClientAppExcep: this.contractsmethod(i).controls[0].get("ClientAppExcep").value,
          // ClientInf: this.contractsmethod(i).controls[0].get("ClientInf").value,
          ClientImp: this.contractsmethod(i).controls[0].get("ClientImp").value,
          MitigationComment: this.contractsmethod(i).controls[0].get("MitigationComment").value
        })
      }
      
    }
  }

  this.chkLength = 0;
  for (let k = 1; k < this.quantities().controls[i].get("contracts_array").value.length ; k++) {

    if(this.contractsmethod(i).controls[k].value.chkList)
    this.chkLength++;
  }

  // if(this.chkLength < (this.quantities().controls[i].get("contracts_array").value.length -1))
  if(this.chkLength == this.contArrLength)
  {
    if (!this.contractsmethod(i).controls[0].value.chkList)
    this.contractsmethod(i).controls[0]
        .patchValue({
          chkList : checked
        })
  }

  if(this.chkLength < this.contArrLength)
  {
    //commented below line because 1st row is disabled and below doesnt work in this case
    //if (this.contractsmethod(i).controls[0].value.chkList)
    this.contractsmethod(i).controls[0]
        .patchValue({
          chkList : false
        })
  }

        for (let k = 0; k < this.quantities().controls[i].get("contracts_array").value.length; k++) {

          if (j != 0) {
            if (!this.contractsmethod(i).controls[j].value.chkList) {
              this.contractsmethod(i).controls[j]
                .patchValue({
                  DoAccManage: null,
                  ImpactedVersion: null,
                  AppliedCorrAction: null,
                  remediationraised: null,
                  ClientAppExcep: null,
                  // ClientInf: null,
                  ClientImp: null,
                  MitigationComment: null
                });

                this.contractsmethod(i).controls[j]
                .patchValue({
                  DoAccManage: null,
                  ImpactedVersion: null,
                  AppliedCorrAction: null,
                  remediationraised: null,
                  ClientAppExcep: null,
                  // ClientInf: null,
                  ClientImp: null,
                  MitigationComment: null
                });

              if (this.appliedColor != "grey") {
                this.contractsmethod(i).controls[j].get('DoAccManage').enable();
              }
              // else {
              //   this.contractsmethod(i).controls[j].get('ClientInf').enable();
              // }
            }

          }
          else if(j ==0){
            if (!this.contractsmethod(i).controls[k].value.chkList) {
              this.contractsmethod(i).controls[k]
                .patchValue({
                  DoAccManage: null,
                  ImpactedVersion: null,
                  AppliedCorrAction: null,
                  remediationraised: null,
                  ClientAppExcep: null,
                  // ClientInf: null,
                  ClientImp: null,
                  MitigationComment: null
                });

              if (this.appliedColor != "grey") {
                this.contractsmethod(i).controls[k].get('DoAccManage').enable();
              }
              // else {
              //   this.contractsmethod(i).controls[j].get('ClientInf').enable();
              // }

            }
          }
          

          if(!this.contractsmethod(i).controls[0].value.chkList){
                
            this.contractsmethod(i).controls[0].get('DoAccManage').enable();
            // this.contractsmethod(i).controls[0].get('ImpactedVersion').enable();
            // this.contractsmethod(i).controls[0].get('AppliedCorrAction').enable();
            // this.contractsmethod(i).controls[0].get('remediationraised').enable();
            // this.contractsmethod(i).controls[0].get('ClientAppExcep').enable();
            // this.contractsmethod(i).controls[0].get('ClientInf').enable();
            // this.contractsmethod(i).controls[0].get('ClientImp').enable();
        }
        }
        

        // this.togglePanels(i);

        this.contArrLength = this.quantities().controls[i].get("contracts_array").value.length - 1;
        this.grCheckCount = 0;
        
  for (let j = 0; j < this.quantities().controls[i].get("contracts_array").value.length; j++) {
    var ConValdata = new IUpdateContract();
    this.grCheckFlag = false;
    ConValdata.contract = this.contractsmethod(i).controls[j].get("contract").value;
    ConValdata.remediationraised = this.contractsmethod(i).controls[j].get("remediationraised").value;
    //ConValdata.DoAccManage = this.contractsmethod(index).controls[j].get("DoAccManage").value;
    ConValdata.DoAccManage = (this.contractsmethod(i).controls[j].get("DoAccManage").value == null) ? null : this.contractsmethod(i).controls[j].get("DoAccManage").value;
    ConValdata.ImpactedVersion = this.contractsmethod(i).controls[j].get("ImpactedVersion").value;
    ConValdata.AppliedCorrAction = this.contractsmethod(i).controls[j].get("AppliedCorrAction").value;
    ConValdata.ClientAppExcep = this.contractsmethod(i).controls[j].get("ClientAppExcep").value;
    // ConValdata.ClientInf = this.contractsmethod(i).controls[j].get("ClientInf").value;
    ConValdata.ClientImp = this.contractsmethod(i).controls[j].get("ClientImp").value;
    ConValdata.CommentAct = this.contractsmethod(i).controls[j].get("CommentAct").value;
    ConValdata.MitigationComment = this.contractsmethod(i).controls[j].get("MitigationComment").value;
    ConValdata.ContractVulStatus = "";

    ConVal.push(ConValdata);
    console.log("into chk change loop");
    console.log(ConVal[j]);

    if (this.contractsmethod(i).controls[j].get("client").value != "Template") {

      // if ((ConVal[j].DoAccManage != "" || ConVal[j].ImpactedVersion != "" || ConVal[j].AppliedCorrAction != "" || ConVal[j].remediationraised != "" ||
      //   ConVal[j].ClientAppExcep != "" || ConVal[j].ClientInf != "" || ConVal[j].ClientImp != "")
      //   && (ConVal[j].DoAccManage != null || ConVal[j].ImpactedVersion != null || ConVal[j].AppliedCorrAction != null || ConVal[j].remediationraised != null ||
      //     ConVal[j].ClientAppExcep != null || ConVal[j].ClientInf != null || ConVal[j].ClientImp != null)) {
        console.log("in CL call ");
        console.log(i);
        console.log(j);
        console.log(ConVal[j]);
        this.checkchangecommaction("DoAccManage" + i + j, ConVal[j].DoAccManage);
        this.checkchangecommaction("ImpactedVersion" + i + j, ConVal[j].ImpactedVersion);
        this.checkchangecommaction("AppliedCorrAction" + i + j, ConVal[j].AppliedCorrAction);
        this.checkchangecommaction("remediationraised" + i + j, ConVal[j].remediationraised);
        this.checkchangecommaction("ClientAppExcep" + i + j, ConVal[j].ClientAppExcep);
        this.checkchangecommaction("ClientImp" + i + j, ConVal[j].ClientImp);
        // this.checkchangecommaction("ClientInf" + i + j, ConVal[j].ClientInf);
        
      // }

    }

  }

  console.log("into chk change");
  console.log(ConVal);

  // if (this.contractsmethod(i).controls[0].value.chkList) {
    for (let k = 1; k < this.quantities().controls[i].get("contracts_array").value.length; k++) {
      // this.contractsmethod(i).controls[k]
      //   .patchValue({
      //     chkList: checked
      //   })

      // if (checked) {
        this.contractsmethod(i).controls[k]
          .patchValue({
            DoAccManage: ConVal[k].DoAccManage,
            ImpactedVersion: ConVal[k].ImpactedVersion,
            AppliedCorrAction: ConVal[k].AppliedCorrAction,
            remediationraised: ConVal[k].remediationraised,
            ClientAppExcep: ConVal[k].ClientAppExcep,
            // ClientInf: ConVal[k].ClientInf,
            ClientImp: ConVal[k].ClientImp,
            MitigationComment: ConVal[k].MitigationComment
          })
      // }
    }
  // }

  if(this.chkLength > 0 && this.chkLength < this.contArrLength && this.grCheckCount != this.contArrLength){
    if (this.quantities().controls[this.indexExpanded].get('status').value == 'Complete' ||
    this.quantities().controls[this.indexExpanded].get('status').value == 'Not Started') {
      console.log("Status NS: " + this.grCheckCount + this.contArrLength);
      
        this.quantities().controls[this.indexExpanded].patchValue({
          status: 'In Progress'
        })
    }
  }

  var FilterDataD = {
    UserID : this.Eid,   
    VID :   this.quantities().controls[i].get("VID").value,
    Index:i,
  ContractDDList:this.quantities().controls[i].get("contracts_array").value, 
  DelegateDDSelected:this.quantities().controls[i].get("Delegate_array").value   
}
  this.getNewDelegateDD(FilterDataD);
}

tempChangeCommAction(i : any, j : any){
  if(j==0){
    for (let k = 0; k < this.quantities().controls[i].get("contracts_array").value.length; k++) {
          if(k!=0){
            this.contractsmethod(i).controls[k]
          .patchValue({
            DoAccManage : this.contractsmethod(i).controls[0].get("DoAccManage").value,
            ImpactedVersion:this.contractsmethod(i).controls[0].get("contract").value,
            AppliedCorrAction : this.contractsmethod(i).controls[0].get("AppliedCorrAction").value,
            remediationraised : this.contractsmethod(i).controls[0].get("remediationraised").value,
            ClientAppExcep:this.contractsmethod(i).controls[0].get("ClientAppExcep").value,
            ClientInf:this.contractsmethod(i).controls[0].get("ClientInf").value,
            ClientImp:this.contractsmethod(i).controls[0].get("ClientImp").value,
            MitigationComment : this.contractsmethod(i).controls[0].get("MitigationComment").value
          })
          }
          
    }
  }
}

  notanyContract(indexNum: number) {
    for (let j = 0; j < this.quantities().controls[indexNum].get("contracts_array").value.length; j++) {

      this.contractsmethod(indexNum).controls[j]
        .patchValue({
          DoAccManage: null,
          ImpactedVersion: null,
          AppliedCorrAction: null,
          remediationraised: null,
          ClientAppExcep: null,
          // ClientInf: null,
          ClientImp: null,
          MitigationComment: null
        })

        if(this.contractsmethod(indexNum).controls[j].value.chkList)
          {
            this.contractsmethod(indexNum).controls[j]
          .patchValue({
            chkList : false
          })
          }

          this.contractsmethod(this.indexExpanded).controls[j].get('DoAccManage').disable();
          if(this.contractsmethod(indexNum).controls[j].get("client").value != "Template")
          this.contractsmethod(indexNum).controls[j].patchValue({
            DoAccManage: 'No'
          });
          this.contractsmethod(this.indexExpanded).controls[j].get('ImpactedVersion').disable();
          this.contractsmethod(this.indexExpanded).controls[j].get('ClientAppExcep').disable();
          this.contractsmethod(this.indexExpanded).controls[j].get('AppliedCorrAction').disable();
          this.contractsmethod(this.indexExpanded).controls[j].get('remediationraised').disable();
    
          // this.contractsmethod(this.indexExpanded).controls[j].get('ClientInf').enable();
          this.contractsmethod(this.indexExpanded).controls[j].get('ClientImp').disable();
    
    }

    this.quantities().controls[this.indexExpanded].patchValue({
      // status: 'In Progress'
      status: 'Complete'
    })
    this.appliedColor = "grey";
    this.grCheckCount = 0;
    this.grCount = 0;

  }

getNewDelegateDD(FilterData:any){
  this.DDdata =FilterData.ContractDDList

  for (let j = 0; j < this.quantities().controls[FilterData.Index].get("Delegate_array").value.length; j++) {
    console.log(FilterData.DelegateDDSelected[j].contractnumber);
    console.log(FilterData.DelegateDDSelected[j].delegates);
    this.selectDel[j] = FilterData.DelegateDDSelected[j].contractnumber
    //this.selectDelName[j] = FilterData.DelegateDDSelected[j].delegates

  }

  for (let j = 0; j < this.quantities().controls[FilterData.Index].get("Delegate_array").value.length; j++) {
    console.log(FilterData.DelegateDDSelected[j].delegates);
    this.selectDelName[j] = FilterData.DelegateDDSelected[j].delegates
    this.delegatemethod(FilterData.Index).controls[j].patchValue(
      {
        delegates : this.selectDelName[j]
      }
    );
    
  }

  if(this.quantities().controls[FilterData.Index].get("Delegate_array").value.length > 0){
    this.delDisable = false;
  }
  
}

getSelectedDel(contNumber : any){
  let chkVal = false;
  // const selDel = FilterData.DelegateDDSelected[0].contractnumber;
  for(let i=0 ; i < this.selectDel.length ; i++){
    if(this.selectDel[i] == contNumber){
      chkVal = true;
      if(chkVal)
      { 
        console.log("breaking");
        break;}
    }
  }
  return chkVal;
  //return this.selectDel;
}

valChangedforDel(value : any,indexDel : any,event : any){
  console.log(value)
  // console.log(this.myForm.value)
  // this.checkAutocomplete= this.itemNameList.includes(value)
  event.target.value = value;
  var target = event.target || event.srcElement || event.currentTarget;
let idattr = target.attributes.id;
var secondindex = idattr.nodeValue;
// this.filteredOptions = this.productForm.get(['quantities',this.currentindex, 'Delegate_array',secondindex,'delegates']).valueChanges.pipe(              
//   startWith(''),
//   map(value => this._filter(value || '')),  
//   // map(value => this._filter(event.target.value , 'S')),          
// );

this.filteredOptions = this.productForm.get(['quantities',this.currentindex, 'Delegate_array',secondindex,'delegates']).
valueChanges.pipe(              
  startWith<string>(''),
  // map(value => this._filter(value || '')),   
  map(value => this._filter(event.target.value || '')),    
  map(value => value),  
);

// this.productForm.get(['quantities',this.currentindex, 'Delegate_array',secondindex,'delegates']).
// valueChanges.subscribe(value  => {
// // this._filter(value || '')
// const filterValue = value.toLowerCase();
// this.options= this.getUsersLDAP(filterValue);
// if(value!=""){
// }
// console.log("val :");
// console.log(this.options);
// return value;

// });

console.log("search : " +this.filteredOptions);

}

PanelClose(){
  console.log("Panel close start");
  var FilterData = {};
  var date = new Date(this.productForm.get('Filter_DueDate').value),
  mnth = ("0" + (date.getMonth() + 1)).slice(-2),
  day = ("0" + date.getDate()).slice(-2);
  var DueDate = [date.getFullYear(), mnth, day].join("-");
  var Status=this.productForm.get('Filter_Status').value;
  console.log(DueDate);
  if( Status!="" && (DueDate=="NaN-aN-aN"||DueDate=="")){
    console.log("Status is present and DueDate is empty");
     FilterData = {
      UserID : this.Eid, 
      Status: Status,
  } 
  }
  else if(Status=="" && (!(DueDate=="NaN-aN-aN"||DueDate==""))){
    console.log("Status is not present and DueDate is present");
     FilterData = {
      UserID : this.Eid, 
      DueDate: DueDate,
  } 
  }
  else if(Status!="" && (!(DueDate=="NaN-aN-aN"||DueDate==""))){
    console.log("Status and DueDate are present");
    FilterData = {
      UserID : this.Eid, 
      Status: Status,
      DueDate: DueDate,
  } 
  }
  else if(Status=="" && (DueDate=="NaN-aN-aN"||DueDate=="")){
    console.log("Both status and duedate are present");
    FilterData = {
      UserID : this.Eid,
    }
  }
 console.log("get user data on panel close start");
 console.log(FilterData)
  this.getUserViewData(FilterData);    
    this.disableSelect = true;
    this.indexExpanded = -1;
this.grCount=0;
this.grCheckCount = 0;
this.appliedColor = "";
console.log("close panel end");
}
  addQuantity() {
    this.quantities().push(this.newQuantity());
  }
   
  removeQuantity(i:number) {
    this.quantities().removeAt(i);
  }
  
  quantities() : UntypedFormArray {
    return this.productForm.get("quantities") as UntypedFormArray
  }   
  

  newQuantity(): UntypedFormGroup {
    return this.fb.group({
VID:"",         
delegate: "",
deliveryteamcomment: "",
correctiveaction: "",
description: "",
status: "",
title: "",
dateraised: "",
LastUpdatedBy: "",
flag: "",
Buttonforbtn:"",
contracts_array:this.fb.array([]),
//contTemp_array:this.fb.array([]),
Delegate_array:this.fb.array([]),
UrlList : this.fb.array([])
}
)}

urlmethod(i:number) : UntypedFormArray {
      return this.quantities().at(i).get("UrlList") as UntypedFormArray
    }
  delegatemethod(i:number) : UntypedFormArray {
        return this.quantities().at(i).get("Delegate_array") as UntypedFormArray
      }
contractsmethod(i:number) : UntypedFormArray {
      return this.quantities().at(i).get("contracts_array") as UntypedFormArray
    }

  contTempmethod(i:number) : UntypedFormArray {
        return this.quantities().at(i).get("contTemp_array") as UntypedFormArray
      }

    addcontract(i:number) {
        this.contractsmethod(i).push(this.newcontract());
      }

    addcontTemp(i:number) {
          this.contTempmethod(i).push(this.newcontTemplate());
        }

  newcontract(): UntypedFormGroup {
      return this.fb.group({
  client: '',
  contract: '',
  contract_name: '',
  remediationraised:"",
  DoAccManage : "",
  ImpactedVersion:"",
  AppliedCorrAction : "",
  ClientAppExcep : "",
  ClientInf : "",
  ClientImp : "",
  CommentAct : "",
  MitigationComment:""
  //,contTemp_array:this.fb.array([])
  //VrID : ""
      })
    }

  newcontTemplate(): UntypedFormGroup {
        return this.fb.group({
    client: '',
    // contract: '',
    // contract_name: '',
    tempremediationraised:"",
    tempDoAccManage : "",
    tempImpactedVersion:"",
    tempAppliedCorrAction : "",
    tempClientAppExcep : "",
    tempClientInf : "",
    tempClientImp : "",
    tempCommentAct : "",
    tempMitigationComment:"",
    //VrID : ""
        })
      }

        removecontract(i:number,j:number) {
          this.contractsmethod(i).removeAt(j);
        }

  ngOnInit(): void {   
    setTimeout(() => {
      var FilterData = {
        UserID: this.Eid,
      }

      //   this.filteredOptions = this.myControl.valueChanges.pipe(        
      //   startWith(''),
      //   map(value => this._filter(value || '')),        
      // );

      this.getUserViewData(FilterData);

      //this.getUserViewData(FilterData);  
      this.getEVMail();
      this.disableSelect = true;
    });
}

ngAfterContentChecked(): void {
  this.cdRef.detectChanges();
}

displayFn(data: any): string {
  let dtOptions = '';

  console.log("flgCnt : "+UserViewVulnerabilityComponent.flgCnt);
  
  if(UserViewVulnerabilityComponent.flgCnt == 0 ){
    UserViewVulnerabilityComponent.flgCnt = 1;
     dtOptions = data ?data : '';
    //dtOptions = this.displayFn(data);
    // return (option: any) => this.displayFn(option);
  }
  //return data ?data : '';
  console.log("dtOptions : "+dtOptions);
  
   return dtOptions;
}

displayWrapper(){
  let dtOptions = '';

  if(this.flgCount == 0 ){
    this.flgCount = 1;
    // dtOptions = data ?data : '';
    dtOptions = this.displayFn(data);
    // return (option: any) => this.displayFn(option);
  }
  // else{
  //   return '';
  // }

  return dtOptions;
  // return (option: any) => this.displayFn(option);
  // return this.options;
}

// ngAfterViewInit(){
//   var FilterData = {
//     UserID : this.Eid,         
// } 
//   setTimeout(() => {
//     this.getUserViewData(FilterData); 
//     // this.cdRef.detectChanges();
//   }, 0);
  
// //   var FilterData = {
// //     UserID : this.Eid,         
// // } 

// //   this.getUserViewData(FilterData);  
// //   this.getEVMail(); 
// //     this.disableSelect = true;
// }

onSearchKeydown(event:any,i : any,j : any){
var target = event.target || event.srcElement || event.currentTarget;
let idattr = target.attributes.id;
var secondindex = idattr.nodeValue;
let myArray: any[] = event.target.attributes.id.value.split(/([0-9]+)/);
let numSearch = myArray[1];
console.log("onsearchkeydown i : "+i);
console.log("onsearchkeydown j : "+j);
console.log("onsearchkeydown currentindex : "+this.currentindex);
console.log("on search numSearch : "+numSearch.toString().substring(this.indexExpanded.toString().length, numSearch.toString().length));

  this.filteredOptions = this.productForm.get(['quantities', this.currentindex, 'Delegate_array', numSearch.toString().substring(this.indexExpanded.toString().length, numSearch.toString().length), 'delegates'])
  .valueChanges.pipe(
    startWith<string>(""),
    //startWith(''),
    // map(value => this._filter(value || '')),  
    map(value => this._filter(event.target.value || '')),
  );

/* adding above to take second index from node value
this.filteredOptions = this.productForm.get(['quantities',this.currentindex, 'Delegate_array',secondindex,'delegates']).valueChanges.pipe(              
  startWith(''),
  // map(value => this._filter(value || '')),  
  map(value => this._filter(event.target.value || '')),          
);
**/
// this.productForm.get(['quantities',this.currentindex, 'Delegate_array',secondindex,'delegates']).valueChanges.pipe(              
//   startWith(''),
//   // map(value => this._filter(value || '')),  
//   map(value => this._filter(event.target.value || '')),          
// );
console.log("opt ");
console.log(this.options);
console.log("search : " +this.filteredOptions);
}

isOptionSelected(event: any,i : any,j:any) {
  UserViewVulnerabilityComponent.flgCnt = 0;
  this.selectedValue = event.option.value
  console.log("sel vlaue :");
  console.log(this.selectedValue);
  if (this.selectedValue) {
    this.delegatemethod(i).controls[j].patchValue(
      {
        delegates : this.selectedValue
      }
    )
    //this.form.controls.targetListValue.disable();
    // this.filteredOptions = new Observable<string[]>;
    console.log("delegate selected : "+this.delegatemethod(i).controls[j].get("delegates").value);
    
    console.log("isOptionSelected len : " +this.filteredOptions);
    console.log("isOptionSelected len : " +this.filteredOptions);
  }
}

  addDelegate(i:number) {
    console.log("add delegate : "+i);
    this.flgCount = 1;
    UserViewVulnerabilityComponent.flgCnt = 1;
    this.delegatemethod(i).push(this.newDelegate());
    // this.delegatemethod(i).push(
    //   this.fb.group({
    //     contractnumber : [['']],
    //     delegates:[['']]
    //   })
    // );
    console.log("data log add Delegate");
    console.log(this.quantities().at(i).get("Delegate_array").value);
    // this.filteredOptions = [] as unknown as Observable<string[]>;
    this.delDisable = false;
    const valDelegateLength = this.quantities().at(i).get("Delegate_array").value.length - 1;
    this.delegatemethod(i).controls[valDelegateLength].setValue(
      {
        contractnumber:[['']],
        delegates : [['']]
      }
    )
    // this.filteredOptions = new Observable<string[]>;
    console.log("search addDelegate val : " +this.filteredOptions);
  }
  
  removeDelegate(i:number,j:number) {
    this.delegatemethod(i).removeAt(j);
  }

  newDelegate(): UntypedFormGroup {
    return this.fb.group({
      contractnumber:[['']],      
      delegates: [['']],
      // delegates: new FormControl(null),
    })
  }


// private _filter(value: string, key: string): string[] { 
  private _filter(value: string): string[] { 
  const filterValue = value.toLowerCase();
this.options= this.getUsersLDAP(filterValue);
if(this.options==null && filterValue!=""){
}
console.log(this.options)
return this.options
  // return this.options.filter(option => option.toLowerCase().includes(filterValue));
}

getUsersLDAP(userid:any){    
  this.service.getusersldap(userid).subscribe((data : any)=>{      
    this.PeoplePicker = data;   
  }, (error:any) => {
      this.errorMessage = error;
  })
  return this.PeoplePicker
}

getEVMail(){
  this.service.getEVMailData().subscribe((data : any)=>{      
    this.EmailData = data; 
  }, (error:any) => {
      // this.errormessage = error;
  })
}

 
  SetQtyValue(qtySet : IVul[]): UntypedFormArray{
//     console.log("This is to see1")
//     console.log(qtySet[0].contracts_array);
//     let test : Array<{VID:number,contract:string,contractname:string}> =[];
//     for(let i=0;i<qtySet[0].contracts_array.length;i++)
//     {
//       var data:any;
// console.log(qtySet[0].contracts_array[0].contract)
// data= qtySet[0].contracts_array[i].contract;
// test.push({'VID':data,'contract':data,'contractname':data})
//     }
//     console.log(test)



    const formmarray = new UntypedFormArray([]);
    if(this.contFill == 2){
      qtySet.forEach(s => {
        formmarray.push(this.fb.group({       
          VID : s.VID,
          title : s.title,
          //status : s.status,
          status : (s.status == null || s.status == "")? "Not Started" : s.status,
          description : s.description,
          dateraised : s.dateraised,
          correctiveaction : s.correctiveaction,
          deligate : s.deligate,
          deliveryteamcomment : s.deliveryteamcomment,
          LastUpdatedBy : s.LastUpdatedBy,
           flag : (this.Eid == s.LastUpdatedBy && s.status == "Complete")? "true":"false",
          //flag : (this.Eid == "sharad.singh.singh" && s.status == "Complete")? "true":"false",
          //Buttonforbtn : "",
          contracts_array: this.setDefaultcontracts(s),
          //contTemp_array: this.setDefaultcontracts(s),
          Delegate_array:this.setDefaultdelegate(s), 
          notAnyContract : s.notAnyContract         
        }));
      });      
    }
    else{
      qtySet.forEach(s => {
        formmarray.push(this.fb.group({     
          VID : s.VID,
          title : s.title,
          //status : s.status,
          status : (s.status == null || s.status == "")? "Not Started" : s.status,
          description : s.description,
          dateraised : s.dateraised,
          correctiveaction : s.correctiveaction,
          deligate : s.deligate,
          deliveryteamcomment : s.deliveryteamcomment,
          LastUpdatedBy : s.LastUpdatedBy,
           flag : (this.Eid == s.LastUpdatedBy && s.status == "Complete")? "true":"false",
          //flag : (this.Eid == "sharad.singh.singh" && s.status == "Complete")? "true":"false",
          //Buttonforbtn : "",
          contracts_array:this.setcontracts(s),
          //contTemp_array: this.setcontTemp(s),
          Delegate_array:this.setDefaultdelegate(s),
          //UrlList : (this.setUrlList(s) == null)? "" : this.setUrlList(s)
          UrlList : this.setUrlList(s),
          notAnyContract : s.notAnyContract
        }));
      });   

    }    

    // console.log("flag...")
    // console.log(formmarray.value)
    // for (let w = 0; w < formmarray.length; w++) {
    //   //console.log("setQTY Loop")
    //  if (formmarray.controls[w].get("flag").value) {
    //    console.log("inside if...")
    //    console.log(formmarray.controls[w].get("Buttonforbtn").value);
    //   formmarray.controls[w].get("Buttonforbtn").disable();
    //  }
      
    // }
    // for (let index = 0; index < formmarray.length; index++) {
    //   if (this.quantities().controls[index].get("flag").value==true) {
    //     //formmarray.controls[index].con
      
    //   } 
    // }
    // console.log(formmarray.controls[0].get("status").value);
    // for (let index = 0; index < formmarray.length; index++) {
    //   //console.log(this.quantities().controls[index].get("status").value);
    //   //console.log(this.Eid == "angela.k.stott" && formmarray.status == "Complete");
    //   if (this.Eid == "angela.k.stott" && formmarray.controls[0].get("status").value == "Complete") {
    //     console.log("abcd")
    //     console.log(qtySet.length);
    //     //this.contractsmethod(0).controls[index].get("ClientInf").disable();
    //     //this.productForm.get(['quantities',0,'contracts_array',0,'ClientImp']).disable();
    //   }
      
    // }
    return formmarray;
  }

  setUrlList(x:any){
    let arr = new UntypedFormArray([])
    x.vuURL.forEach((y: { URLList:any;}) => {
      arr.push(this.fb.group({ 
        dataurl: y.URLList
      }))     
    });
    return arr;
  }
  OpenPopUpPage(value : number){
    console.log("open mtd "+value);
    //var vUrl = this.productForm.controls["quantities"].value[value].dataurl
    var vUrl = this.quantities().at(this.indexExpanded).get("UrlList").value[value].dataurl
    if(vUrl.startsWith("https://")){
      vUrl = vUrl.replace("https://","");
    }
    if((vUrl != null || vUrl != undefined))
    // (window as any).open(vUrl, "_blank");
    (window as any).open("https://"+vUrl, "_blank");
    // window.location.assign(value)
    //window.open(value, "_blank");
  };

  checkConTemp(cont : any,j: any){
    let flag =false;
    
    // for(let k=0 ; k < this.contractsmethod.length; k++){
      this.ContData = this.quantities().controls[cont].get("contracts_array").value
    // }
    let clientcont;

    if(this.ContData.length > j)
    clientcont = this.ContData[j].client;
    // for(let i = 0 ; i< this.ContData.length; i++)
    // {
    //   cont = this.ContData[i].client;
    // }
      if(clientcont == "Template"){
      flag = true;
    }
    else{
      this.num = this.num+1;
      flag = false;
    }
    return flag;
  }
  setcontracts(x:any) {
    let arr = new UntypedFormArray([])
      x.contracts_array.forEach((y: { client: any; contract: any;contract_name:any;remediationraised:any
        ;DoAccManage : any;ImpactedVersion:any;AppliedCorrAction : any;ClientAppExcep : any;ClientInf : any;ClientImp : any,CommentAct : any;MitigationComment:any
        ,chkList : any,FlagDelegate : any
        // tempclient: any;tempremediationraised:any
        // ;tempDoAccManage : any;tempImpactedVersion:any;tempAppliedCorrAction : any;tempClientAppExcep : any;tempClientInf : any;tempClientImp : any,tempCommentAct : any;tempMitigationComment:any;
      }) => {
        // console.log("tempc "+y.tempclient);
        // this.tempClient = y.tempclient;
          // if(y.tempclient == "Template"){
          //   arr.push(this.fb.group({ 
          //     //tempclient: y.tempclient ,
          //     tempremediationraised:(y.tempremediationraised == "" || y.tempremediationraised == null || y.tempremediationraised == "0001-01-01T00:00:00")? "":y.tempremediationraised,                 
          //     tempDoAccManage : y.tempDoAccManage,
          //     tempImpactedVersion: y.tempImpactedVersion,
          //     tempAppliedCorrAction : y.tempAppliedCorrAction,
          //     tempClientAppExcep : y.tempClientAppExcep,
          //     tempClientInf : y.tempClientInf,
          //     tempClientImp : y.tempClientImp,
          //     tempCommentAct : y.tempCommentAct,
          //     tempMitigationComment:y.tempMitigationComment
          //     //,contTemp_array: this.setcontTemp(y)
          //   }))
          // }else{
            arr.push(this.fb.group({ 
              client: y.client ,
              contract: y.contract ,
              contract_name: y.contract_name,
              remediationraised:(y.remediationraised == "" || y.remediationraised == null || y.remediationraised == "0001-01-01T00:00:00")? "":y.remediationraised,                 
              DoAccManage : y.DoAccManage,
              ImpactedVersion: y.ImpactedVersion,
              AppliedCorrAction : y.AppliedCorrAction,
              ClientAppExcep : y.ClientAppExcep,
              ClientInf : y.ClientInf,
              ClientImp : y.ClientImp,
              CommentAct : y.CommentAct,
              MitigationComment:y.MitigationComment
              ,chkList: y.chkList
              ,FlagDelegate : y.FlagDelegate
              // ,tempremediationraised:"",                 
              // tempDoAccManage : "",
              // tempImpactedVersion: "",
              // tempAppliedCorrAction : "",
              // tempClientAppExcep : "",
              // tempClientInf : "",
              // tempClientImp : "",
              // tempCommentAct : "",
              // tempMitigationComment: ""
              //,contTemp_array: this.setcontTemp(y)
            }))
          //}
        
               
      });
    
     //console.log("in contract..");
     //console.log(x.VID);
    for (let u = 0; u < arr.length; u++) {
      
      if(u==0){
        arr.controls[u].patchValue({tempDoAccManage : "No"})
      }
      if (this.Eid != x.LastUpdatedBy && x.status == "Complete") {
        //console.log("inside con loop");
        //console.log(x.Button);
        //x.Button.disable();
        
        //console.log(x.LastUpdatedBy);
        //console.log(arr.controls[u].get("remediationraised").value);
        arr.controls[u].get("remediationraised").disable();
        arr.controls[u].get("DoAccManage").disable();
        arr.controls[u].get("ImpactedVersion").disable();
        arr.controls[u].get("AppliedCorrAction").disable();
        arr.controls[u].get("ClientAppExcep").disable();
        arr.controls[u].get("ClientInf").disable();
        arr.controls[u].get("ClientImp").disable();
      }
    }

    return arr;
  }

  setcontTemp(x:any) {
    let arr = new UntypedFormArray([])
      x.contTemp_array.forEach((y: { client: any; tempremediationraised:any
        ;tempDoAccManage : any;tempImpactedVersion:any;tempAppliedCorrAction : any;tempClientAppExcep : any;tempClientInf : any;tempClientImp : any,tempCommentAct : any;tempMitigationComment:any;}) => {
        arr.push(this.fb.group({ 
          client: y.client ,
          // contract:y.contract ,
          // contract_name:y.contract_name,
          
          tempremediationraised:(y.tempremediationraised == "" || y.tempremediationraised == null || y.tempremediationraised == "0001-01-01T00:00:00")? "":y.tempremediationraised,                 
          tempDoAccManage : y.tempDoAccManage,
          tempImpactedVersion: y.tempImpactedVersion,
          tempAppliedCorrAction : y.tempAppliedCorrAction,
          tempClientAppExcep : y.tempClientAppExcep,
          tempClientInf : y.tempClientInf,
          tempClientImp : y.tempClientImp,
          tempCommentAct : y.tempCommentAct,
          tempMitigationComment:y.tempMitigationComment
        }))     
      });
    
     //console.log("in contract..");
     //console.log(x.VID);
     /*
    for (let u = 0; u < arr.length; u++) {
      
      if (this.Eid != x.LastUpdatedBy && x.status == "Complete") {
        //console.log("inside con loop");
        //console.log(x.Button);
        //x.Button.disable();
        
        //console.log(x.LastUpdatedBy);
        //console.log(arr.controls[u].get("remediationraised").value);
        arr.controls[u].get("remediationraised").disable();
        arr.controls[u].get("DoAccManage").disable();
        arr.controls[u].get("ImpactedVersion").disable();
        arr.controls[u].get("AppliedCorrAction").disable();
        arr.controls[u].get("ClientAppExcep").disable();
        arr.controls[u].get("ClientInf").disable();
        arr.controls[u].get("ClientImp").disable();
      }
    }
    **/

    return arr;
  }

  setcontractsData(x:IContract[]):UntypedFormArray {
    let arr = new UntypedFormArray([])
    x.forEach((y: { client: any; contract: any;contract_name:any;remediationraised:any
      ;DoAccManage : any;ImpactedVersion : any;AppliedCorrAction : any;ClientAppExcep : any;ClientInf : any;ClientImp : any,CommentAct : any;MitigationComment:any}) => {
      arr.push(this.fb.group({ 
        client: y.client ,
        contract:y.contract ,
        contract_name:y.contract_name,
        remediationraised:(y.remediationraised == "" || y.remediationraised == null || y.remediationraised == "0001-01-01T00:00:00")? "":y.remediationraised,                 
        DoAccManage : y.DoAccManage,
        ImpactedVersion: y.ImpactedVersion,
        AppliedCorrAction : y.AppliedCorrAction,
        ClientAppExcep : y.ClientAppExcep,
        ClientInf : y.ClientInf,
        ClientImp : y.ClientImp,
        CommentAct : y.CommentAct,
        MitigationComment: y.MitigationComment
      }))     
    })
     //console.log("in contract..");
     //console.log(x.VID);
    // for (let u = 0; u < arr.length; u++) {
      
    //   if (this.Eid != x.LastUpdatedBy && x.status == "Complete") {
    //     arr.controls[u].get("remediationraised").disable();
    //     arr.controls[u].get("DoAccManage").disable();
    //     arr.controls[u].get("AppliedCorrAction").disable();
    //     arr.controls[u].get("ClientAppExcep").disable();
    //     arr.controls[u].get("ClientInf").disable();
    //     arr.controls[u].get("ClientImp").disable();
    //   }
    // }
    return arr;
  }

  setDefaultcontracts(x:any) {
    let arr = new UntypedFormArray([])
    x.contracts_array.forEach((y: { client: any; contract: any;contract_name:any;remediationraised:any
      ;DoAccManage : any;ImpactedVersion:any;AppliedCorrAction : any;ClientAppExcep : any;ClientInf : any;ClientImp : any,CommentAct : any;MitigationComment:any}) => {
      arr.push(this.fb.group({
        client: y.client,
        contract: y.contract,
        contract_name: y.contract_name,
        remediationraised: y.remediationraised,
        DoAccManage: y.DoAccManage,
        ImpactedVersion: y.ImpactedVersion,
        AppliedCorrAction: y.AppliedCorrAction,
        ClientAppExcep: y.ClientAppExcep,
        ClientInf: y.ClientInf,
        ClientImp: y.ClientImp,
        CommentAct: y.CommentAct,
        MitigationComment: y.MitigationComment
      }))     
    })
     
    return arr;
  }

  setDefaultdelegate(x:any) {
    let arr = new UntypedFormArray([])
    x.vuDel.forEach((y: { VID:any;contractnumber:any;contractname:any[];delegates:any}) => {
      arr.push(this.fb.group({ 
        VID: y.VID,
        contractnumber:[this.commatoarray(y.contractnumber)],
        contractname:y.contractname,
        delegates:y.delegates        
      }))     
    });     
    return arr;
  }

  commatoarray(contractnumber:any){
    let myarray:any[];
    myarray=contractnumber.split(',');    
    return myarray;
    // for(let i=0;i<contractnumber.)
  }

   convert(DateConv: any) {
      var date = new Date(DateConv),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      return [day,mnth,date.getFullYear()].join("-");
    }

    ClearDD():void
    {
      this.productForm.patchValue({Filter_Status:""})
      this.productForm.patchValue({Filter_DueDate:""})
      var FilterData = {
        UserID : this.Eid, 
        Status : ""        
    } 
      this.getUserViewData(FilterData);
    }
  FilterFormArray(){

    if((this.productForm.get('Filter_DueDate').value)=="") {
      var FilterData = {
        UserID: this.Eid,
        Status: this.productForm.get('Filter_Status').value
      }
      this.getUserViewData(FilterData);
    }

    else {

      var date = new Date(this.productForm.get('Filter_DueDate').value),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      var DueDate = [date.getFullYear(), mnth, day].join("-");
      console.log(DueDate)

      var FilterData2 = {
        UserID: this.Eid,
        Status: this.productForm.get('Filter_Status').value,
        DueDate: DueDate
      }

      this.getUserViewData(FilterData2);
    }


  }
    
    dateChangeEvent(event: { value: any; targetElement : any}){
      console.log("date change");
      if(event.value!=null){
        console.log(event.value._d);
        console.log(event.targetElement.id);
        this.changecommaction(event.targetElement.id,event.value._d);
      }
    }

  checkchangecommaction(i: any, j: any) {
    let DoAccManage = ""; let ImpactedVersion = ""; let AppliedCorrAction = ""; let ClientAppExcep = ""; let ClientInf = ""
    let ClientImp = ""; let remediationRasied = ""; let contractNumber = "";
    console.log("inside");
    console.log(i);
    console.log(j);
    let myArray: any[] = i.split(/([0-9]+)/)
    console.log("b4 id");
    console.log(myArray[0]);
    console.log(myArray[1]);
    let Id = myArray[0]
    let Number = myArray[1]
    let FirstNumber = Math.round(Number / 10);
    console.log("grCount " + this.grCheckCount);
    //Storing everthing in an array
    var element = { id: i, value: j };
    element.id = i;
    element.value = j;

    //Get Today's Date
    let CurrentDate = moment().format("DD-MM-YYYY");
    let SplitCurrentDate = CurrentDate.split("-")
    let dateDiff: number;
    //Get DatePicker Value
    let split_Number = Number.toString().split('').map((iNum: string) => parseInt(iNum, 10));
    console.log("sp number : " + split_Number[1]);
    console.log("Number : " + Number);
    console.log("First NUm " + FirstNumber);
    console.log(this.quantities().length);
    console.log("indexExpanded");
    console.log(this.indexExpanded);
    console.log(this.quantities().at(this.indexExpanded).get("contracts_array") as UntypedFormArray);
    console.log("count");
    console.log("Current Date");
    console.log(CurrentDate);
    let listControl;
    try {
      listControl = this.quantities().at(this.indexExpanded).get("contracts_array") as UntypedFormArray;
    }
    catch (err) {
      console.log("in error");
      console.log(err);
    }

    //console.log("list "+listControl.controls[split_Number[1]].value.remediationraised._d);
    //console.log("cont "+listControl.controls[split_Number[1]].value.contract);
    //let firstControl= (listControl.controls[split_Number[1]].value.remediationraised != null) ? this.convert(listControl.controls[split_Number[1]].value.remediationraised._d) : "aN";
    let firstControl = (listControl.controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)].value.remediationraised != null) ?
      this.convert(listControl.controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)].value.remediationraised) : "aN";
    console.log("firstControl number : " + firstControl);

    console.log("VUDate ");
    console.log(this.quantities().controls[this.indexExpanded].get("dateraised").value);
    console.log("Remidiation date raised ");
    console.log(this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)].get('remediationraised').value);
    console.log("rem date got");
    let raisedDateVal = this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)].get('remediationraised').value;

    raisedDateVal = (raisedDateVal != null && raisedDateVal > 0) ? raisedDateVal : firstControl;

    console.log(raisedDateVal);

    if (!(raisedDateVal == "" || raisedDateVal == "aN")) {
      console.log("calling calculate");
      dateDiff = this.calculateDiffdate(raisedDateVal, this.quantities().controls[this.indexExpanded].get("dateraised").value);
    }

    console.log("DateDiff : " + dateDiff);
    let SplitDate = (firstControl.length > 0) ? firstControl.split("-") : "aN";
    console.log("SplitDate : " + SplitDate);
    //Convert DB Date Format
    if (SplitDate.length == 1) {
      if ((SplitDate[1] == "aN") && (listControl.controls[split_Number[1]].value.remediationraised) != "") {
        let dateString = listControl.controls[split_Number[1]].value.remediationraised;
        var allDate = dateString.split(':');
        var thisDate = allDate[0].split('-');
        var thisTime = allDate[1].split(':');
        var newDate = [thisDate[2].slice(0, 2), thisDate[1], thisDate[0]].join("-");
        let newDate_Array = newDate.split("-");
        SplitDate = newDate_Array;
      }
    }


    let checkinside = 0;
    for (let i = 0; i < this.cart.length; i++) {
      if (this.cart[i].id == element.id) {
        this.cart[i].value = element.value;
        checkinside = 1;
      }
    }

    if (checkinside == 0) {
      this.cart.push(element);
    }

    for (let i = 0; i < this.cart.length; i++) {
      if (this.cart[i].id == "DoAccManage" + Number) {
        DoAccManage = this.cart[i].value;
      }
      if (this.cart[i].id == "ImpactedVersion" + Number) {
        ImpactedVersion = this.cart[i].value;
      }
      if (this.cart[i].id == "AppliedCorrAction" + Number) {
        AppliedCorrAction = this.cart[i].value;
      }
      if (this.cart[i].id == "ClientAppExcep" + Number) {
        ClientAppExcep = this.cart[i].value;
      }
      if (this.cart[i].id == "ClientInf" + Number) {
        ClientInf = this.cart[i].value;
      }
      if (this.cart[i].id == "ClientImp" + Number) {
        ClientImp = this.cart[i].value;
      }
    }
    // contractNumber = listControl.controls[split_Number[1]].value.contract;
    //Check if seleced date is current date
    let Today_Date_Check = 0;
    // for(i=0;i<3;i++)
    // {
    if (SplitCurrentDate[0] == SplitDate[0] && SplitCurrentDate[1] == SplitDate[1] && SplitCurrentDate[2] == SplitDate[2]) {
      Today_Date_Check++;
    }
    //}

    let dateCompare: number;
    let remediationraisedVal = this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)].get('remediationraised').value;

    remediationraisedVal = (remediationraisedVal != null && remediationraisedVal > 0) ? remediationraisedVal : firstControl;

    console.log(remediationraisedVal);
    if (remediationraisedVal > 0 && remediationraisedVal != null) {
      console.log("calling calculate remediationraisedVal");
      dateCompare = this.calculateDiffdatewithCurrDate(remediationraisedVal);
    }

    console.log("dateCompare : " + dateCompare);
    console.log("Today_Date_Check : " + Today_Date_Check);
    console.log("DoAccManage : " + DoAccManage);
    console.log("ImpactedVersion:" + ImpactedVersion);
    console.log("ClientInf : " + ClientInf);
    console.log("ClientAppExcep : " + ClientAppExcep);
    console.log("AppliedCorrAction : " + AppliedCorrAction);
    if (this.overAllGrCnt != Number) {
      this.overAllGrCnt = Number;
      this.grFlag = false;
    }

    let keepExcepDisabled = false, keepAppCorrDisabled = false, keepRemDateDisabled = false;

    let rowNum = Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length);

    try {

      let prevValue = this.ConValPrevData[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)].DoAccManage;
      if (DoAccManage != prevValue && (prevValue != "" || prevValue.toString() != "null") && element.id.startsWith("DoAccManage")) {
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .patchValue({
            ImpactedVersion: null,
            AppliedCorrAction: null,
            remediationraised: null,
            ClientAppExcep: null,
            ClientInf: null,
            ClientImp: null,
            MitigationComment: null
          })

        // this.ConValPrevData[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)].DoAccManage = DoAccManage;
        ImpactedVersion = null;
        AppliedCorrAction = null;
        remediationRasied = null;
        ClientAppExcep = null;
        ClientInf = null;
        ClientImp = null;

        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('AppliedCorrAction').disable();
        console.log("Disabled the corrective action");
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('remediationraised').disable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('ClientAppExcep').disable();
          if(this.appliedColor == "grey"){
            this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('ClientInf').enable();
          }
          else{
            this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('ClientInf').disable();
          }
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('ClientImp').disable();


      }


      if (DoAccManage == null && ImpactedVersion == null) {
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('DoAccManage').enable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('AppliedCorrAction').disable();
        console.log("Disabled the corrective action");
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('remediationraised').disable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('ClientAppExcep').disable();
          /*
          if(this.appliedColor == "grey"){
            this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('ClientInf').enable();
          }
          else{
            this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('ClientInf').disable();
          }
        **/
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('ClientImp').disable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('ImpactedVersion').disable();
        keepExcepDisabled = true;
        keepRemDateDisabled = true;
        keepAppCorrDisabled = true;

        if (rowNum != 0 && this.appliedColor != "grey" && this.quantities().controls[this.indexExpanded].get('status').value != 'In Progress') {
          this.quantities().controls[this.indexExpanded].patchValue({
            status: 'Not Started'
          })

          /* commented on 3rd Jul 24
          if (this.grCheckCount != 0 && this.grCheckCount == this.contArrLength) {
            this.grCheckCount = this.grCheckCount - 1;
            this.grCheckFlag = false;
          }
          **/

          // if (this.grFlag == false && this.grCount != this.contArrLength) {
          //   this.grCount = ++this.grCount;
          //   this.grFlag = true;
          // }
        }

        if (rowNum != 0 && this.appliedColor == "grey" && (ClientInf != null || ClientInf != "")) {
          this.quantities().controls[this.indexExpanded].patchValue({
            status: 'In Progress'
          })
        }

      }

      if (DoAccManage != null && ImpactedVersion == null) {
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('AppliedCorrAction').disable();
        console.log("Disabled the corrective action");
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('remediationraised').disable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('ClientAppExcep').disable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('ClientInf').enable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('ClientImp').disable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('ImpactedVersion').disable();
        keepExcepDisabled = true;
        keepRemDateDisabled = true;
        keepAppCorrDisabled = true;
        this.grCheckFlag = false;
      }

      if (DoAccManage == "Yes") {
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('ImpactedVersion').enable();

          if (rowNum != 0) {
            this.quantities().controls[this.indexExpanded].patchValue({
              // status: 'Risk Validation'//changed condition as per r1s3
              status: 'In Progress'
            });
          }
      }
      // if(DoAccManage=="No" && ImpactedVersion == "No"){//changed condition as per r1s3
      if (DoAccManage == "No") {

        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .patchValue({
            AppliedCorrAction: null,
            remediationraised: null,
            ClientAppExcep: null,
          });

        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('ImpactedVersion').disable();//disabled as per r1s3 condition
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('AppliedCorrAction').disable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('remediationraised').disable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('ClientAppExcep').disable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('ClientInf').enable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('ClientImp').disable();//disabled as per r1s3 condition

        AppliedCorrAction = null;
        ClientAppExcep = null;
        Today_Date_Check = 0;
        keepExcepDisabled = true;
        keepRemDateDisabled = true;
        keepAppCorrDisabled = true;

        // if(ClientInf=="Yes"&&ClientImp=="No"){//changed condition as per r1s3
        // if (ClientInf == "Yes") {
          if (rowNum != 0) {
            this.quantities().controls[this.indexExpanded].patchValue({
              status: 'Complete'
            })

            var constEleID = element.id;
            console.log("const data clientinf CC : "+constEleID.includes("ClientInf"))

            if (this.grCheckFlag == false && this.grCheckCount != this.contArrLength && constEleID.includes("DoAccManage")) {
              this.grCheckCount = ++this.grCheckCount;
              this.grCheckFlag = true;
            }

            // if (this.grFlag == true && this.grCheckCount != this.contArrLength) {
            //   this.grCheckCount = ++this.grCheckCount;
            //   this.grFlag = true;
            // }

          }

        // }
/*
        // if(ClientInf=="Yes"&& ClientImp=="Yes") {//changed condition as per r1s3
        if (ClientInf == "No") {
          if (rowNum != 0) {
            this.quantities().controls[this.indexExpanded].patchValue({
              // status: 'Risk Validation'//changed condition as per r1s3
              status: 'In Progress'
            });

            if (this.grCheckCount != 0 && this.grCheckCount == this.contArrLength) {
              this.grCheckCount = this.grCheckCount - 1;
              this.grCheckFlag = false;
            }
          }

        }
**/
        
      }

      if (DoAccManage == "Yes" && ImpactedVersion == "No") {

        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .patchValue({
            AppliedCorrAction: null,
            remediationraised: null,
            ClientAppExcep: null,
          })
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('ImpactedVersion').enable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('AppliedCorrAction').disable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('remediationraised').disable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('ClientAppExcep').disable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('ClientInf').enable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('ClientImp').disable();//disabled as per r1s3 condition

          if (rowNum != 0) {

            // if (ClientImp == "No") {//changed condition as per r1s3
            this.quantities().controls[this.indexExpanded].patchValue({
              status: 'Complete'
            })
            if (this.grCheckFlag == false && this.grCheckCount != this.contArrLength) {
              this.grCheckCount = ++this.grCheckCount;
              this.grCheckFlag = true;
            }
          }

          /* changed on 3rd Jul 24
        if (ClientInf == "Yes") {
          if (rowNum != 0) {

            // if (ClientImp == "No") {//changed condition as per r1s3
            this.quantities().controls[this.indexExpanded].patchValue({
              status: 'Complete'
            })
            if (this.grCheckFlag == false && this.grCheckCount != this.contArrLength) {
              this.grCheckCount = ++this.grCheckCount;
              this.grCheckFlag = true;
            }
            // if (this.grFlag == true && this.grCheckCount != this.contArrLength) {
            //   this.grCheckCount = ++this.grCheckCount;
            //   this.grFlag = true;
            // }
            //}
            // else if (ClientImp == "Yes") {
            //   this.quantities().controls[this.indexExpanded].patchValue({
            //     status: 'Risk Validation'
            //   })
            // }
          }
        }
        else if (ClientInf == "No") {
          // if (ClientImp == "Yes") {//changed condition as per r1s3
          if (rowNum != 0) {
            this.quantities().controls[this.indexExpanded].patchValue({
              status: 'In Progress'
            });

            if (this.grCheckCount != 0 && this.grCheckCount == this.contArrLength) {
              this.grCheckCount = this.grCheckCount - 1;
              this.grCheckFlag = false;
            }
          }
          // }
          // else if (ClientImp == "No") {
          //   this.quantities().controls[this.indexExpanded].patchValue({
          //     status: 'Complete'
          //   })
          //   if (this.grFlag == false && this.grCount != this.contArrLength) {
          //     this.grCount = ++this.grCount;
          //     this.grFlag = true;
          //   }
          // }
        }
        **/
      }

      if (DoAccManage == "Yes" && ImpactedVersion == "Yes") {
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('ClientInf').enable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('ClientImp').enable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('AppliedCorrAction').disable();//disabled as per r1s3 condition    
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('remediationraised').disable();//disabled as per r1s3 condition
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('ClientAppExcep').enable();

          
        if (ClientAppExcep == "Yes") {
          const varAppCorAction = this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)].get("AppliedCorrAction").value;
          const varremediationraised = this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)].get("remediationraised").value;
          const varClientImp = this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)].get("ClientImp").value;
          
          if(varAppCorAction != null || varAppCorAction != ''){
            this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .patchValue({
            AppliedCorrAction: null,
            // remediationraised: null,
            // ClientAppExcep: null,
          })
          }

          if(varremediationraised != null || varremediationraised != ''){
            this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .patchValue({
            // AppliedCorrAction: null,
            remediationraised: null,
            // ClientAppExcep: null,
          })
          }

          /* changed on 3rd Jul 24
          if(varClientImp != null || varClientImp != ''){
            this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .patchValue({
            // AppliedCorrAction: null,
            // remediationraised: null,
            varClientImp: null,
          })
          }
          **/

          //if (ClientInf == "Yes" || ClientInf == "No") {
            if (ClientImp == "No") {
            
            if (rowNum != 0) {

              // if (ClientImp == "No") {//changed condition as per r1s3
              this.quantities().controls[this.indexExpanded].patchValue({
                status: 'Complete'
              })
              if (this.grCheckFlag == false && this.grCheckCount != this.contArrLength) {
                this.grCheckCount = ++this.grCheckCount;
                this.grCheckFlag = true;
              }
            }
          }

          if (ClientImp == "Yes") {
            
            if (rowNum != 0) {

              // if (ClientImp == "No") {//changed condition as per r1s3
              this.quantities().controls[this.indexExpanded].patchValue({
                status: 'In Progress'
              })
              if (this.grCheckCount != 0 && this.grCheckCount == this.contArrLength) {
                this.grCheckCount = this.grCheckCount - 1;
                this.grCheckFlag = false;
              }
              }
            }
        }

        if (ClientAppExcep == "No" || ClientAppExcep == "N/A") {
          this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
            .get('AppliedCorrAction').enable();

            this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
              .get('ClientImp').disable();

              var constEleImpID = element.id;
        var constEleIDValue = element.value;
        console.log("Check Change comm const data Imp for PA: " + constEleImpID.includes("ClientImp") + " , "+ constEleIDValue);

        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
              .patchValue({
                ClientImp: null
              })

          if (AppliedCorrAction == "Patch applied" || AppliedCorrAction == "Workaround applied") {
            this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
              .get('ClientImp').enable();

            this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
              .patchValue({
                remediationraised: null
              })

              this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
              .get('remediationraised').disable();

              this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
                .patchValue({
                  ClientImp : constEleIDValue
                }) 

            // if (ClientImp == "Yes" && ClientInf == "Yes") {
            if ((ClientImp == "No" || ClientImp == "N/A")) {
              if (rowNum != 0) {
                this.quantities().controls[this.indexExpanded].patchValue({

                  status: 'Complete'

                });

                if (this.grCheckFlag == false && this.grCheckCount != this.contArrLength) {
                  this.grCheckCount = ++this.grCheckCount;
                  this.grCheckFlag = true;
                }

                // if (this.grCheckCount != 0 && this.grCheckCount == this.contArrLength) {
                //   this.grCheckCount = this.grCheckCount - 1;
                //   this.grCheckFlag = false;
                // }
              }
            }

            // if ((ClientImp == "No" || ClientImp == "N/A") && ClientInf == "Yes") {
            if (ClientImp == "Yes") {
              if (rowNum != 0) {
                this.quantities().controls[this.indexExpanded].patchValue({

                  status: 'In Progress'

                })

                if (this.grCheckCount != 0 && this.grCheckCount == this.contArrLength) {
                  this.grCheckCount = this.grCheckCount - 1;
                  this.grCheckFlag = false;
                }

                // if (this.grCheckFlag == false && this.grCheckCount != this.contArrLength) {
                //   this.grCheckCount = ++this.grCheckCount;
                //   this.grCheckFlag = true;
                // }
              }
            }

            /*
            if ((ClientImp == "No" || ClientImp == "N/A") && ClientInf == "No") {
              if (rowNum != 0) {
                this.quantities().controls[this.indexExpanded].patchValue({

                  status: 'In Progress'

                });

                if (this.grCheckCount != 0 && this.grCheckCount == this.contArrLength) {
                  this.grCheckCount = this.grCheckCount - 1;
                  this.grCheckFlag = false;
                }
              }
            }
            **/

          }

          /*
          if (AppliedCorrAction == "Workaround applied") {
            this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
              .get('ClientImp').enable();

            this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
              .patchValue({
                remediationraised: null
              })

            if (ClientImp == "Yes" && ClientInf == "Yes") {
              if (rowNum != 0)
                this.quantities().controls[this.indexExpanded].patchValue({

                  status: 'In Progress'

                });

              if (this.grCheckCount != 0 && this.grCheckCount == this.contArrLength) {
                this.grCheckCount = this.grCheckCount - 1;
                this.grCheckFlag = false;
              }
            }

            if ((ClientImp == "No" || ClientImp == "N/A") && ClientInf == "Yes") {
              if (rowNum != 0) {
                this.quantities().controls[this.indexExpanded].patchValue({

                  status: 'Complete'

                })

                if (this.grCheckFlag == false && this.grCheckCount != this.contArrLength) {
                  this.grCheckCount = ++this.grCheckCount;
                  this.grCheckFlag = true;
                }
                // if (this.grFlag == true && this.grCheckCount != this.contArrLength) {
                //   this.grCheckCount = ++this.grCheckCount;
                //   this.grFlag = true;
                // }
              }
            }

            if ((ClientImp == "No" || ClientImp == "N/A") && ClientInf == "No") {
              if (rowNum != 0)
                this.quantities().controls[this.indexExpanded].patchValue({

                  status: 'In Progress'

                });

              if (this.grCheckCount != 0 && this.grCheckCount == this.contArrLength) {
                this.grCheckCount = this.grCheckCount - 1;
                this.grCheckFlag = false;
              }
            }

          }
          **/

          if (AppliedCorrAction == "No") {
            this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
              .get('remediationraised').enable();

            this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
              .get('ClientImp').enable();

            // if (ClientImp == "Yes" && ClientInf == "Yes" && remediationraisedVal != null) {
              if (ClientImp == null && remediationraisedVal == null) {
              if (rowNum != 0)
                this.quantities().controls[this.indexExpanded].patchValue({
                  status: 'In Progress'
                  // status: 'Risk Validation'

                });

              if (this.grCheckCount != 0 && this.grCheckCount == this.contArrLength) {
                this.grCheckCount = this.grCheckCount - 1;
                this.grCheckFlag = false;
              }
            }

            // if ((ClientImp == "No" || ClientImp == "N/A") && (ClientInf == "No" || ClientInf == "Yes") && remediationraisedVal != null) {
              if ((ClientImp == "No" || ClientImp == "Yes") && remediationraisedVal != null) {
              if (rowNum != 0)
                this.quantities().controls[this.indexExpanded].patchValue({

                  status: 'In Progress'//need to check if Risk Validation or IP from Rob as per excel its confusing

                });

              if (this.grCheckCount != 0 && this.grCheckCount == this.contArrLength) {
                this.grCheckCount = this.grCheckCount - 1;
                this.grCheckFlag = false;
              }
            }
          }
        }

        
      }

      if (DoAccManage == null && ImpactedVersion == null && ClientAppExcep == null && AppliedCorrAction == null && (remediationraisedVal == null || remediationraisedVal == "aN") && ClientImp == null) {
        var constEleID = element.id;
            console.log("const data clientinf CC : "+constEleID.includes("ClientInf"));

        if (ClientInf != null && this.appliedColor == "grey" && constEleID.includes("ClientInf")) {
          this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
            .get('DoAccManage').disable();
          this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
            .get('AppliedCorrAction').disable();
          this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
            .get('remediationraised').disable();
          this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
            .get('ClientAppExcep').disable();
          this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
            .get('ClientInf').enable();
          this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
            .get('ClientImp').disable();
          this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
            .get('ImpactedVersion').disable();

          if (this.grCheckFlag == false && this.grCheckCount != this.contArrLength) {
            this.grCheckCount = ++this.grCheckCount;
            this.grCheckFlag = true;
          }

          if(this.contArrLength == this.grCheckCount){
            if (rowNum != 0) {
              this.quantities().controls[this.indexExpanded].patchValue({
                status: 'Complete'
              })
            }
          }
          else{
            if (rowNum != 0) {
              this.quantities().controls[this.indexExpanded].patchValue({
                status: 'In Progress'
              })
            }
          }          

        }
      }

      // if(DoAccManage=="Yes" && ImpactedVersion=="Yes"&& AppliedCorrAction==null&& (Today_Date_Check == 0 || Today_Date_Check >0) && ClientAppExcep==null&&ClientInf==null&&ClientImp==null){
      //   this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
      //   .get('AppliedCorrAction').enable();    
      // this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
      // .get('remediationraised').enable();
      // this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
      // .get('ClientAppExcep').enable();
      // this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
      // .get('ClientInf').enable();
      // this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
      // .get('ClientImp').enable();
      //   keepExcepDisabled = false;
      // keepRemDateDisabled = false;
      // keepAppCorrDisabled = false;
      // }

      // if(DoAccManage == "Yes" && ImpactedVersion=="Yes" && AppliedCorrAction == "Yes" && ClientAppExcep==null && ClientInf=="Yes" && ClientImp == "No"){

      //   // this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
      //   // .get('ClientAppExcep').enable();
      //   // keepExcepDisabled = false;

      //   this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
      //   .patchValue({
      //     remediationraised :new Date()

      //   })
      //   this.quantities().controls[this.indexExpanded].patchValue({

      //     status : 'Complete'

      //    })



      //   if(this.grFlag == false){

      //     this.grCount = ++this.grCount;

      //     this.grFlag = true;

      //   }
      // }


    }
    catch (err) {
      console.log("in error");
      console.log(err);
    }
    let chkColumns: any;

    if (!(DoAccManage == null || DoAccManage == "")) {
      chkColumns = "Data Exists";
      console.log("Checking for data in que1");
    } else {
      chkColumns = "";
    }
    console.log("quant status after validating all if conditions");
    console.log(this.quantities().controls[this.indexExpanded].get('status').value);
    console.log("grCheckCount after validating all if conditions" + this.grCheckCount);
    console.log("element.id chk : "+element.id);
    // if (this.contArrLength == this.grCount) {
    //   this.quantities().controls[this.indexExpanded].patchValue({
    //     status : 'Complete'
    //   })
    // }
    // Teperory Solution for Complete Status By Ujjwal  
    if (this.quantities().controls[this.indexExpanded].get('status').value == 'Complete'
      && this.contArrLength == this.grCheckCount) {
      console.log("Status Complete: " + this.grCheckCount + this.contArrLength);
      if (rowNum != 0) {
        this.quantities().controls[this.indexExpanded].patchValue({
          status: 'Complete'
        })
      }

    }
    // else 
    // if(this.contArrLength == this.grCheckCount){
    //   console.log("setting status complete based on grCheckCount" +this.grCheckCount);
      
    //   if (rowNum != 0) {
    //     this.quantities().controls[this.indexExpanded].patchValue({
    //       status: 'Complete'
    //     })
    //   }
    // }
	
    else if (chkColumns == "" && this.quantities().controls[this.indexExpanded].get('status').value != 'In Progress') {
      if (this.quantities().controls[this.indexExpanded].get('status').value != 'Complete') {
        console.log("STATUS: NOT STARTED");
        if (rowNum != 0)
          this.quantities().controls[this.indexExpanded].patchValue({
            status: 'Not Started'
          })
      }
    }
    else {
      console.log("Conditions Not listed in Excel");
      if (rowNum != 0)
        this.quantities().controls[this.indexExpanded].patchValue({
          status: 'In Progress'
        })
    }

  }

    changecommaction(i:any,j:any) {
      let DoAccManage="";let ImpactedVersion = "";let AppliedCorrAction="";let ClientAppExcep="";let ClientInf=""
      let ClientImp="";let remediationRasied = "";let contractNumber ="";
          console.log("inside");
          console.log(i);
          console.log(j);
          let myArray:any [] = i.split(/([0-9]+)/)
          console.log("b4 id");
          console.log(myArray[0]);
          console.log(myArray[1]);
          let Id= myArray[0]
         let Number=myArray[1]
          let FirstNumber=Math.round(Number/10);
          console.log("grCount "+this.grCount);
    //Storing everthing in an array
    var element = {id:i,value:j};
    element.id = i;
    element.value = j;
    
    //Get Today's Date
    let CurrentDate = moment().format("DD-MM-YYYY");
    let SplitCurrentDate =CurrentDate.split("-")
    let dateDiff : number;
    //Get DatePicker Value
    let split_Number=Number.toString().split('').map((iNum: string) => parseInt(iNum, 10));
    console.log("sp number : "+split_Number[1]);
    console.log("Number : "+Number);
    console.log("First NUm " +FirstNumber);
    console.log(this.quantities().length);
    console.log("indexExpanded");
    console.log(this.indexExpanded);
    console.log(this.quantities().at(this.indexExpanded).get("contracts_array") as UntypedFormArray);
    console.log("count");
    console.log("Current Date");
    console.log(CurrentDate);
    let listControl ;
    try{
      listControl = this.quantities().at(this.indexExpanded).get("contracts_array") as UntypedFormArray;
    }
    catch(err){
      console.log("in error");
      console.log(err);
    }
    
    //console.log("list "+listControl.controls[split_Number[1]].value.remediationraised._d);
    //console.log("cont "+listControl.controls[split_Number[1]].value.contract);
    //let firstControl= (listControl.controls[split_Number[1]].value.remediationraised != null) ? this.convert(listControl.controls[split_Number[1]].value.remediationraised._d) : "aN";
    let firstControl= (listControl.controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)].value.remediationraised != null) ? 
                      this.convert(listControl.controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)].value.remediationraised) : "aN";
    console.log("firstControl number : "+firstControl);
    
    console.log("VUDate ");
    console.log(this.quantities().controls[this.indexExpanded].get("dateraised").value);
    console.log("Remidiation date raised ");
    console.log(this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)].get('remediationraised').value);
    console.log("rem date got");
    let raisedDateVal = this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)].get('remediationraised').value;
    
    raisedDateVal = (raisedDateVal != null && raisedDateVal > 0 )? raisedDateVal : firstControl;
    
    console.log(raisedDateVal);
    
    if(!(raisedDateVal== "" || raisedDateVal == "aN" )){
      console.log("calling calculate");
      dateDiff = this.calculateDiffdate(raisedDateVal,this.quantities().controls[this.indexExpanded].get("dateraised").value);
    }
    
    console.log("DateDiff : " +dateDiff);
    let SplitDate= (firstControl.length > 0)? firstControl.split("-") : "aN";
    console.log("SplitDate : "+SplitDate);
    //Convert DB Date Format
    if(SplitDate.length == 1){
      if((SplitDate[1]=="aN")&&(listControl.controls[split_Number[1]].value.remediationraised)!="")
      {
      let dateString = listControl.controls[split_Number[1]].value.remediationraised;
      var allDate = dateString.split(':');
      var thisDate = allDate[0].split('-');
      var thisTime = allDate[1].split(':');
      var newDate = [thisDate[2].slice(0,2),thisDate[1],thisDate[0] ].join("-");
      let newDate_Array=newDate.split("-");
      SplitDate=newDate_Array;
      }
    }
    
    
    let checkinside=0;
    for (let i = 0; i < this.cart.length; i++) {
      if(this.cart[i].id == element.id) {
        this.cart[i].value = element.value;
        checkinside=1;    
      }
    }
    
    if(checkinside==0)
    {  
    this.cart.push(element);
    }
    
    for (let i = 0; i < this.cart.length; i++) {
      if(this.cart[i].id =="DoAccManage"+Number ) {
        DoAccManage=this.cart[i].value;       
      }
      if(this.cart[i].id =="ImpactedVersion"+Number ) {
        ImpactedVersion=this.cart[i].value;       
      }
      if(this.cart[i].id =="AppliedCorrAction"+Number ) {
        AppliedCorrAction=this.cart[i].value;       
      }
      if(this.cart[i].id =="ClientAppExcep"+Number ) {
        ClientAppExcep=this.cart[i].value;       
      }
      if(this.cart[i].id =="ClientInf"+Number ) {
        ClientInf=this.cart[i].value;       
      }
      if(this.cart[i].id =="ClientImp"+Number ) {
        ClientImp=this.cart[i].value;       
      }
    }
    // contractNumber = listControl.controls[split_Number[1]].value.contract;
    //Check if seleced date is current date
    let Today_Date_Check=0;
    // for(i=0;i<3;i++)
    // {
      if(SplitCurrentDate[0]==SplitDate[0] && SplitCurrentDate[1]==SplitDate[1] && SplitCurrentDate[2]==SplitDate[2])
    {
      Today_Date_Check++;
    }
    //}
    
    let dateCompare: number;
    let remediationraisedVal = this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)].get('remediationraised').value;
    
    remediationraisedVal = (remediationraisedVal != null && remediationraisedVal > 0 )? remediationraisedVal : firstControl;
    
    console.log(remediationraisedVal);
    if(remediationraisedVal > 0 && remediationraisedVal != null ){
      console.log("calling calculate remediationraisedVal");
      dateCompare = this.calculateDiffdatewithCurrDate(remediationraisedVal);
    }
    
    console.log("dateCompare : "+dateCompare);
    console.log("Today_Date_Check : "+Today_Date_Check);
    console.log("DoAccManage : "+DoAccManage);
    console.log("ImpactedVersion:"+ImpactedVersion);
    console.log("ClientInf : "+ClientInf);
    console.log("ClientAppExcep : "+ClientAppExcep);
    console.log("AppliedCorrAction : "+AppliedCorrAction);
    console.log("ClientImp : "+ClientImp);
    if(this.overAllGrCnt != Number){
      this.overAllGrCnt = Number;
      this.grFlag = false;
    }
    
    let keepExcepDisabled = false,keepAppCorrDisabled = false,keepRemDateDisabled = false;

    let rowNum = Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length);

    try{

      let prevValue = this.ConValPrevData[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)].DoAccManage;
      if(DoAccManage != prevValue && (prevValue != "" || prevValue.toString() != "null") && element.id.startsWith("DoAccManage")){
          this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
          .patchValue({
            ImpactedVersion:null,
            AppliedCorrAction : null,
            remediationraised : null,
            ClientAppExcep:null,
            ClientInf:null,
            ClientImp:null,
            MitigationComment : null
          })
      
          // this.ConValPrevData[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)].DoAccManage = DoAccManage;
          ImpactedVersion = null;
          AppliedCorrAction = null;
          remediationRasied = null;
          ClientAppExcep = null;
          ClientInf = null;
          ClientImp = null;

          this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
        .get('AppliedCorrAction').disable();
        console.log("Disabled the corrective action");
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
        .get('remediationraised').disable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
        .get('ClientAppExcep').disable();
        // this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
        // .get('ClientInf').disable(); // commented as this column is removed
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
        .get('ClientImp').disable();
        

      }

      
      if(DoAccManage==null && ImpactedVersion==null){
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
        .get('DoAccManage').enable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
        .get('AppliedCorrAction').disable();
        console.log("Disabled the corrective action");
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
        .get('remediationraised').disable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
        .get('ClientAppExcep').disable();
        /* commented as this column has been removed
        if(this.appliedColor == "grey"){
          this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
        .get('ClientInf').enable();
        }
        else{
          this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
        .get('ClientInf').disable();
        }
        **/
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
        .get('ClientImp').disable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
        .get('ImpactedVersion').disable();
        keepExcepDisabled = true;
        keepRemDateDisabled = true;
        keepAppCorrDisabled = true;

        if (rowNum != 0 && this.appliedColor != "grey" && this.quantities().controls[this.indexExpanded].get('status').value != 'In Progress') {
          this.quantities().controls[this.indexExpanded].patchValue({
            status: 'Not Started'
          })
          /* commented as affecting not any contract
          if(this.grCount != 0 && this.grCount != this.contArrLength){
            this.grCount = this.grCount-1;
            this.grFlag = false;
          }
          **/
          // if (this.grFlag == false && this.grCount != this.contArrLength) {
          //   this.grCount = ++this.grCount;
          //   this.grFlag = true;
          // }
        }

        if (rowNum != 0 && this.appliedColor == "grey" && (ClientInf != null || ClientInf != "")) {
          this.quantities().controls[this.indexExpanded].patchValue({
            status: 'In Progress'
          })
        }
    }

    if(DoAccManage !=null && ImpactedVersion==null){
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
        .get('AppliedCorrAction').disable();
        console.log("Disabled the corrective action");
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
        .get('remediationraised').disable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
        .get('ClientAppExcep').disable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
        .get('ClientInf').enable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
        .get('ClientImp').disable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
        .get('ImpactedVersion').disable();
        keepExcepDisabled = true;
        keepRemDateDisabled = true;
        keepAppCorrDisabled = true;
    }

    if(DoAccManage == "Yes"){
      this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
        .get('ImpactedVersion').enable();

        if (rowNum != 0) {
          this.quantities().controls[this.indexExpanded].patchValue({
            // status: 'Risk Validation'//changed condition as per r1s3
            status: 'In Progress'
          });

          // if(this.grCount != 0 && this.grCount != this.contArrLength){
          //   this.grCount = this.grCount-1;
          //   this.grFlag = false;
          // }
        }
    }
    // if(DoAccManage=="No" && ImpactedVersion == "No"){//changed condition as per r1s3
      if(DoAccManage=="No" ){

      this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
      .patchValue({
        AppliedCorrAction : null,
        remediationraised : null,
        ClientAppExcep:null,
      });

      this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
      .get('ImpactedVersion').disable();//disabled as per r1s3 condition
      this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
      .get('AppliedCorrAction').disable();
      this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
      .get('remediationraised').disable();
      this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
      .get('ClientAppExcep').disable();
      this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
      .get('ClientInf').enable();
      this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
      .get('ClientImp').disable();//disabled as per r1s3 condition

      AppliedCorrAction = null;
      ClientAppExcep = null;
      Today_Date_Check = 0;
      keepExcepDisabled = true;
      keepRemDateDisabled = true;
      keepAppCorrDisabled = true; 

      //below if condition added as Client Informed is removed from new matrix
      if (rowNum != 0) {
        this.quantities().controls[this.indexExpanded].patchValue({
          status: 'Complete'
        })

        if (this.grFlag == false && this.grCount != this.contArrLength ) {
          this.grCount = ++this.grCount;
          this.grFlag = true;
        }

      }

      /* section removed on 25th June 2024 as per new requirement, Client Informed is removed 
      // if(ClientInf=="Yes"&&ClientImp=="No"){//changed condition as per r1s3
        if (ClientInf == "Yes") {
          if (rowNum != 0) {
            this.quantities().controls[this.indexExpanded].patchValue({
              status: 'Complete'
            })
            var constEleID = element.id;
            console.log("const data clientinf CC : "+constEleID.includes("ClientInf"))

            if (this.grFlag == false && this.grCount != this.contArrLength && constEleID.includes("ClientInf")) {
              this.grCount = ++this.grCount;
              this.grFlag = true;
            }

            // if (this.grFlag == true && this.grCount != this.contArrLength) {
            //   this.grCount = ++this.grCount;
            //   this.grFlag = true;
            // }

          }
          
        }

      // if(ClientInf=="Yes"&& ClientImp=="Yes") {//changed condition as per r1s3
        if (ClientInf == "No") {
          if (rowNum != 0) {
            this.quantities().controls[this.indexExpanded].patchValue({
              // status: 'Risk Validation'//changed condition as per r1s3
              status: 'In Progress'
            });

            if(this.grCount != 0 && this.grCount != this.contArrLength){
              this.grCount = this.grCount-1;
              this.grFlag = false;
            }
          }

        }
        **/
      
        /* section commented as not required in r1s3 requirement
      if(ClientInf=="No"&& ClientImp=="Yes") {
        this.quantities().controls[this.indexExpanded].patchValue({
          status : 'Risk Validation'
         })
      }
      if(ClientInf=="No"&& ClientImp=="No") {
        this.quantities().controls[this.indexExpanded].patchValue({
          status : 'Complete'
         })
         if(this.grFlag == false && this.grCount!=this.contArrLength){
          this.grCount = ++this.grCount;
          this.grFlag = true;
        }
      }
      **/
    }

    if (DoAccManage == "Yes" && ImpactedVersion=="No") {

      this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
        .patchValue({
          AppliedCorrAction : null,
          remediationraised : null,
          ClientAppExcep: null,
        })
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
        .get('ImpactedVersion').enable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
        .get('AppliedCorrAction').disable();    
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
        .get('remediationraised').disable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
        .get('ClientAppExcep').disable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
        .get('ClientInf').enable();
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
        .get('ClientImp').disable();//disabled as per r1s3 condition

        //added below if condition as per new requirement
      if (rowNum != 0) {
        this.quantities().controls[this.indexExpanded].patchValue({
          status: 'Complete'
        })
        if (this.grFlag == false && this.grCount != this.contArrLength) {
          this.grCount = ++this.grCount;
          this.grFlag = true;
        }

      }

      /* removed section as Client Informed is removed from new requirement 25th June 2024
      if (ClientInf == "Yes") {
        if (rowNum != 0) {

          // if (ClientImp == "No") {//changed condition as per r1s3
          this.quantities().controls[this.indexExpanded].patchValue({
            status: 'Complete'
          })
          if (this.grFlag == false && this.grCount != this.contArrLength) {
            this.grCount = ++this.grCount;
            this.grFlag = true;
          }
          //}
          // else if (ClientImp == "Yes") {
          //   this.quantities().controls[this.indexExpanded].patchValue({
          //     status: 'Risk Validation'
          //   })
          // }
        }
      }
      else if (ClientInf == "No") {
        // if (ClientImp == "Yes") {//changed condition as per r1s3
        if (rowNum != 0){
          this.quantities().controls[this.indexExpanded].patchValue({
            status: 'In Progress'
          });

          if(this.grCount != 0 && this.grCount != this.contArrLength){
            this.grCount = this.grCount-1;
            this.grFlag = false;
          }
        }
        // }
        // else if (ClientImp == "No") {
        //   this.quantities().controls[this.indexExpanded].patchValue({
        //     status: 'Complete'
        //   })
        //   if (this.grFlag == false && this.grCount != this.contArrLength) {
        //     this.grCount = ++this.grCount;
        //     this.grFlag = true;
        //   }
        // }
      }
      **/
    }

    if (DoAccManage == "Yes" && ImpactedVersion=="Yes"){
      this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
      .get('ClientInf').enable();
      this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
      .get('ClientImp').enable();
      this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
      .get('AppliedCorrAction').disable();//disabled as per r1s3 condition    
      this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
      .get('remediationraised').disable();//disabled as per r1s3 condition
      this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
      .get('ClientAppExcep').enable();

      var constEleImpIDdata = element.id;
      if(constEleImpIDdata.includes("ClientImp")){
        var constEleIDValuedata = element.value;
        console.log("const data Imp for PA: " + constEleImpIDdata.includes("ClientImp") + " , "+ constEleIDValuedata);

      }
        
        
      if(ClientAppExcep == "Yes"){

        const varAppCorAction = this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)].get("AppliedCorrAction").value;
        const varremediationraised = this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)].get("remediationraised").value;
        const varClientImp = this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)].get("ClientImp").value;

        if (varAppCorAction != null || varAppCorAction != '') {
          this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
            .patchValue({
              AppliedCorrAction: null,
              // remediationraised: null,
              // ClientAppExcep: null,
            })
        }

        if (varremediationraised != null || varremediationraised != '') {
          this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
            .patchValue({
              // AppliedCorrAction: null,
              remediationraised: null,
              // ClientAppExcep: null,
            })
        }

        /*
        if (varClientImp != null || varClientImp != '') {
          this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
            .patchValue({
              // AppliedCorrAction: null,
              // remediationraised: null,
              ClientImp: null,
            })
        }
        **/
        // if (ClientInf == "Yes") {
          if (ClientImp == "No") {
          if (rowNum != 0) {
            this.quantities().controls[this.indexExpanded].patchValue({

              // status: 'In Progress'
              status: 'Complete'

            })

            // if(this.grCount != 0 && this.grCount != this.contArrLength){
            //   this.grCount = this.grCount-1;
            //   this.grFlag = false;
            // }

            if (this.grFlag == false && this.grCount != this.contArrLength) {
              this.grCount = ++this.grCount;
              this.grFlag = true;
            }
            console.log("grcount if cond :"+this.grCount);
            console.log("grFlag if cond :"+this.grFlag);
          }
        }

        // if (ClientInf == "No") {
          if (ClientImp == "Yes") {
          if (rowNum != 0) {
            this.quantities().controls[this.indexExpanded].patchValue({

              status: 'In Progress'

            })

            // if (this.grFlag == false && this.grCount != this.contArrLength) {
            //   this.grCount = ++this.grCount;
            //   this.grFlag = true;
            // }
            if(this.grCount != 0 && this.grCount != this.contArrLength){
              this.grCount = this.grCount-1;
              this.grFlag = false;
            }
          }
        }

      }

      if (ClientAppExcep == "No" || ClientAppExcep == "N/A") {
        this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('AppliedCorrAction').enable();
          this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('ClientImp').disable();

        var constEleImpID = element.id;
        var constEleIDValue = element.value;
        console.log("const data Imp for PA: " + constEleImpID.includes("ClientImp") + " , "+ constEleIDValue);
        

          this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
                .patchValue({
                  ClientImp : null
                }) 

        if (AppliedCorrAction == "Patch applied" || AppliedCorrAction == "Workaround applied") {
          this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
            .get('ClientImp').enable();

            this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
                .patchValue({
                  remediationraised: null
                }) 
                this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
                .get('remediationraised').disable();

                this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
                .patchValue({
                  ClientImp : constEleIDValue
                }) 

          // if (ClientImp == "Yes" && ClientInf == "Yes") {
          if ((ClientImp == "No" || ClientImp == "N/A")) {
            if (rowNum != 0) {
              this.quantities().controls[this.indexExpanded].patchValue({

                status: 'Complete'

              });

              if (this.grFlag == false && this.grCount != this.contArrLength) {
                this.grCount = ++this.grCount;
                this.grFlag = true;
              }
              
            }
          }

          // if ((ClientImp == "No" || ClientImp == "N/A") && ClientInf == "Yes") {
          if (ClientImp == "Yes") {
            if (rowNum != 0) {
              this.quantities().controls[this.indexExpanded].patchValue({

                status: 'In Progress'

              })

              if (this.grCount != 0 && this.grCount != this.contArrLength) {
                this.grCount = this.grCount - 1;
                this.grFlag = false;
              }
            }
          }

          /* commented on 2nd Jul 24
          if ((ClientImp == "No" || ClientImp == "N/A") && ClientInf == "No") {
            if (rowNum != 0) {
              this.quantities().controls[this.indexExpanded].patchValue({

                status: 'In Progress'

              });

              if(this.grCount != 0 && this.grCount != this.contArrLength){
                this.grCount = this.grCount-1;
                this.grFlag = false;
              }
            }
          }
          **/
        }

        /**  add workaround with patch applied as both have same condition
        if (AppliedCorrAction == "Workaround applied") {
          this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
            .get('ClientImp').enable();

            this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
                .patchValue({
                  remediationraised: null
                })          

          if (ClientImp == "Yes" && ClientInf == "Yes") {
            if (rowNum != 0)
            this.quantities().controls[this.indexExpanded].patchValue({

              status: 'In Progress'

            });

            if(this.grCount != 0 && this.grCount != this.contArrLength){
              this.grCount = this.grCount-1;
              this.grFlag = false;
            }
          }

          if ((ClientImp == "No" || ClientImp == "N/A") && ClientInf == "Yes") {
            if (rowNum != 0) {
              this.quantities().controls[this.indexExpanded].patchValue({

                status: 'Complete'

              })

              if (this.grFlag == false && this.grCount != this.contArrLength) {
                this.grCount = ++this.grCount;
                this.grFlag = true;
              }
            }
          }

          if ((ClientImp == "No" || ClientImp == "N/A") && ClientInf == "No") {
            if(rowNum!=0)
            this.quantities().controls[this.indexExpanded].patchValue({

              status: 'In Progress'

            });

            if(this.grCount != 0 && this.grCount != this.contArrLength){
              this.grCount = this.grCount-1;
              this.grFlag = false;
            }
          }

        }
        */
        if(AppliedCorrAction == "No"){
          this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
          .get('remediationraised').enable();

          this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
            .get('ClientImp').enable();

            if(constEleIDValuedata != null){
              this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
                .patchValue({
                  ClientImp : constEleIDValuedata
                }) 
            }
            

            // if (ClientImp == "Yes" && ClientInf == "Yes" && remediationraisedVal != null) {
              if (ClientImp == null && remediationraisedVal == null) {
              if(rowNum!=0)
              this.quantities().controls[this.indexExpanded].patchValue({
                status: 'In Progress'
                // status: 'Risk Validation'
  
              });

              if(this.grCount != 0 && this.grCount != this.contArrLength){
                this.grCount = this.grCount-1;
                this.grFlag = false;
              }
            }

            // if ((ClientImp == "No" || ClientImp == "N/A") && (ClientInf == "No" || ClientInf == "Yes") && remediationraisedVal != null) {
              if ((ClientImp == "No" || ClientImp == "Yes") && remediationraisedVal != null) {
              if(rowNum!=0)
              this.quantities().controls[this.indexExpanded].patchValue({
  
                status: 'In Progress'//need to check if Risk Validation or IP from Rob as per excel its confusing
  
              });

              if(this.grCount != 0 && this.grCount != this.contArrLength){
                this.grCount = this.grCount-1;
                this.grFlag = false;
              }
            }
        }

      }
      
      /* Commented this section as new validation rules not require these
      if(AppliedCorrAction=="Yes"){
        if (this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)].value['remediationraised'] == ''
          || this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)].value['remediationraised'] == null) {
          this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
            .patchValue({
              remediationraised: new Date()
            })
        }
       
        
        if((raisedDateVal!="aN"||raisedDateVal!="") && ClientAppExcep==null && ClientInf=="Yes" && ClientImp=="No"){
        this.quantities().controls[this.indexExpanded].patchValue({

          status : 'Complete'
    
           })
    
           if(this.grFlag == false && this.grCount!=this.contArrLength){
            this.grCount = ++this.grCount;
            this.grFlag = true;
          }
        }
        else{
          this.quantities().controls[this.indexExpanded].patchValue({

            status : 'In Progress'
      
             })
        }
      }
      else if(AppliedCorrAction == "No") {
        if(raisedDateVal=="aN"||raisedDateVal==""){
          if(ClientAppExcep=="Yes"){
            if(ClientInf == "Yes" && ClientImp == "No"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
            }
            if(ClientInf == "Yes" && ClientInf == "Yes"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
            }
            if(ClientInf == "No" && ClientImp == "Yes"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
            }
            if(ClientInf == "No" && ClientImp == "No"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
            }
          }
          else if (ClientAppExcep="No"){
            if(ClientInf == "Yes" && ClientImp == "Yes"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
            }
            if(ClientInf == "Yes" && ClientImp == "No"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'In Progress'
          
                 })
            }
            if(ClientInf == "No" && ClientImp == "Yes"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
            }
            if(ClientInf == "No" && ClientImp == "No"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'In Progress'
          
                 })
            }
          }
          else if(ClientAppExcep="NA"){
            if(ClientInf == "Yes" && ClientImp == "Yes"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
            }
            if(ClientInf == "Yes" && ClientImp == "No"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'In Progress'
          
                 })
            }
            if(ClientInf == "No" && ClientImp == "Yes"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
            }
            if(ClientInf == "No" && ClientImp == "No"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'In Progress'
          
                 })
            }
          }
        }
        else if((raisedDateVal!="aN"||raisedDateVal!="") && dateDiff < 14){
          if(ClientAppExcep=="Yes"){
            if(ClientInf == "Yes" && ClientImp == "Yes"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
            }
            if(ClientInf == "Yes" && ClientImp == "No"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
            }
            if(ClientInf == "No" && ClientImp == "Yes"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
            }
            if(ClientInf == "No" && ClientImp == "No"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
            }
          }
          else if(ClientAppExcep=="No"){
            if(ClientInf == "Yes" && ClientImp == "Yes"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
            }
            if(ClientInf == "Yes" && ClientImp == "No"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'In Progress'
          
                 })
            }
            if(ClientInf == "No" && ClientImp == "Yes"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
            }
            if(ClientInf == "No" && ClientImp == "No"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'In Progress'
          
                 })
            }
          }
         
        }
        else if ((raisedDateVal!="aN"||raisedDateVal!="") && dateDiff > 14){
          if(ClientAppExcep == "NA"){
            if(ClientInf == "Yes" && ClientImp == "Yes"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
            }
            if(ClientInf == "Yes" && ClientImp == "No"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'In Progress'
          
                 })
            }
          }
        }
        else{
          this.quantities().controls[this.indexExpanded].patchValue({

            status : 'In Progress'
      
             })
        }
        if (dateCompare < 0 && (ClientAppExcep=="No" || ClientAppExcep=="NA") && ClientInf=="Yes" && (ClientImp=="Yes"||ClientImp=="No")){
          console.log("triggering past due date on Vulnerability");
          this.quantities().controls[this.indexExpanded].patchValue({
           
            status : 'In Progress'
      
             })
        }
      }
      else if (AppliedCorrAction=="Workaround applied"){
        if(raisedDateVal=="aN"||raisedDateVal==""){
          if(ClientAppExcep=="No"){
            if(ClientInf=="Yes" && ClientImp=="No"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'In Progress'
          
                 })
            }
            else if(ClientInf=="Yes" && ClientImp=="Yes"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
            }
          }
          else if(ClientAppExcep=="Yes"){
            if(ClientInf == "Yes" && ClientImp=="No"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
            }
            else if(ClientInf=="Yes" && ClientImp=="Yes"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
            }
            else if(ClientInf=="No" && ClientImp=="No"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
            }
            else if(ClientInf=="No" && ClientImp=="Yes"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
            }
          }
        }
        else if ((raisedDateVal!="aN"||raisedDateVal!="") && dateDiff < 14){
          if(ClientAppExcep=="No"){
            if(ClientInf=="Yes" && ClientImp=="No"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'In Progress'
          
                 })
            }
            else if(ClientInf=="Yes" && ClientImp=="Yes"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
            }
          }
          else if(ClientAppExcep=="Yes"){
            if(ClientInf == "Yes" && ClientImp=="No"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
            }
            else if(ClientInf=="Yes" && ClientImp=="Yes"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
            }
            else if(ClientInf=="No" && ClientImp=="No"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
            }
            else if(ClientInf=="No" && ClientImp=="Yes"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
            }
        }
      }
      else{
        this.quantities().controls[this.indexExpanded].patchValue({

          status : 'In Progress'
    
           })
      }
      }
      else if(AppliedCorrAction=="Patch applied"){
      if(raisedDateVal=="aN"||raisedDateVal==""){
        if(ClientAppExcep=="No"){
          if(ClientInf=="Yes" && ClientImp=="No"){
            this.quantities().controls[this.indexExpanded].patchValue({

                status : 'In Progress'
          
                 })
          }
          else if(ClientInf=="Yes" && ClientImp=="Yes"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
          }
        }
        else if(ClientAppExcep=="Yes"){
          if(ClientInf == "Yes" && ClientImp=="No"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
          }
          else if(ClientInf=="Yes" && ClientImp=="Yes"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
          }
          else if(ClientInf=="No" && ClientImp=="No"){
            this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
            })
          }
          else if(ClientInf=="No" && ClientImp=="Yes"){
            this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
            })
          }
        }
      }
      else if ((raisedDateVal!="aN"||raisedDateVal!="") && dateDiff < 14){
          if(ClientAppExcep=="No"){
            if(ClientInf=="Yes" && ClientImp=="No"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Complete'
          
                 })
                 if(this.grFlag == false && this.grCount!=this.contArrLength){
                  this.grCount = ++this.grCount;
                  this.grFlag = true;
                }

            }
            else if(ClientInf=="Yes" && ClientImp=="Yes"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
            }
          }
          else if(ClientAppExcep=="Yes"){
            if(ClientInf == "Yes" && ClientImp=="No"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
            }
            else if(ClientInf=="Yes" && ClientImp=="Yes"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
            }
            else if(ClientInf=="No" && ClientImp=="No"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                 })
            }
            else if(ClientInf=="No" && ClientImp=="Yes"){
              this.quantities().controls[this.indexExpanded].patchValue({

                status : 'Risk Validation'
          
                })
            }
          }
        }
        else{
          this.quantities().controls[this.indexExpanded].patchValue({

            status : 'In Progress'
      
             })
        }
      }
      else{
        this.quantities().controls[this.indexExpanded].patchValue({

          status : 'In Progress'
    
           })
      }
      **/
  } 
   
  if(DoAccManage==null && ImpactedVersion==null && ClientAppExcep == null && AppliedCorrAction == null && (remediationraisedVal == null || remediationraisedVal == "aN") && ClientImp == null){
    var constEleID = element.id;
    console.log("const data clientinf CC : "+constEleID.includes("ClientInf"));

    if (ClientInf != null && this.appliedColor== "grey" && constEleID.includes("ClientInf")) {
      this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
        .get('DoAccManage').disable();
      this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
        .get('AppliedCorrAction').disable();
      this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
        .get('remediationraised').disable();
      this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
        .get('ClientAppExcep').disable();
      this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
        .get('ClientInf').enable();
      this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
        .get('ClientImp').disable();
      this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
        .get('ImpactedVersion').disable();

      // if (rowNum != 0) {
      //   this.quantities().controls[this.indexExpanded].patchValue({

      //     status: 'Complete'

      //   })
      // }
        if (this.grFlag == false && this.grCount != this.contArrLength) {
          this.grCount = ++this.grCount;
          this.grFlag = true;
        }

        if(this.contArrLength == this.grCount){
          if (rowNum != 0) {
            this.quantities().controls[this.indexExpanded].patchValue({
              status: 'Complete'
            })
          }
        }
        else{
          if (rowNum != 0) {
            this.quantities().controls[this.indexExpanded].patchValue({
              status: 'In Progress'
            })
          }
        }
    }
  }


  const contractValue = this.quantities().controls[this.indexExpanded].get('notAnyContract').value

    if (contractValue == "Yes") {
      this.quantities().controls[this.indexExpanded].patchValue({
        // status : 'In Progress'
        status : 'Complete'
      })
      this.appliedColor = "grey";
      this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
        .get('DoAccManage').enable();//Enabled as for not in scope condition changed
      this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
        .get('AppliedCorrAction').disable();
      this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
        .get('remediationraised').disable();
      this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
        .get('ClientAppExcep').disable();
      this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
        .get('ClientInf').disable();
      this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
        .get('ClientImp').disable();
      this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
        .get('ImpactedVersion').disable();

    }
 
    // if(DoAccManage=="Yes" && ImpactedVersion=="Yes"&& AppliedCorrAction==null&& (Today_Date_Check == 0 || Today_Date_Check >0) && ClientAppExcep==null&&ClientInf==null&&ClientImp==null){
    //   this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
    //   .get('AppliedCorrAction').enable();    
    // this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
    // .get('remediationraised').enable();
    // this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
    // .get('ClientAppExcep').enable();
    // this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
    // .get('ClientInf').enable();
    // this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
    // .get('ClientImp').enable();
    //   keepExcepDisabled = false;
    // keepRemDateDisabled = false;
    // keepAppCorrDisabled = false;
    // }
   
    // if(DoAccManage == "Yes" && ImpactedVersion=="Yes" && AppliedCorrAction == "Yes" && ClientAppExcep==null && ClientInf=="Yes" && ClientImp == "No"){
    
    //   // this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
    //   // .get('ClientAppExcep').enable();
    //   // keepExcepDisabled = false;
    
    //   this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length,Number.toString().length)]
    //   .patchValue({
    //     remediationraised :new Date()
        
    //   })
    //   this.quantities().controls[this.indexExpanded].patchValue({

    //     status : 'Complete'

    //    })

       

    //   if(this.grFlag == false){

    //     this.grCount = ++this.grCount;

    //     this.grFlag = true;

    //   }
    // }
    

    }
    catch(err){
      console.log("in error");
      console.log(err);
    }

    if (this.flagDelegate) {

      // this.fillColorFlag = rowNum;
      this.fillColorFlag = 1;
      this.delegateColor = "lightgreen";

      // console.log("Disabled the the row as it is updated by delegated user");
      // this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
      //   .get('DoAccManage').disable();
      // this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
      //   .get('ImpactedVersion').disable();
      // this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
      //   .get('AppliedCorrAction').disable();
      // this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
      //   .get('remediationraised').disable();
      // this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
      //   .get('ClientAppExcep').disable();
      // this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
      //   .get('ClientInf').disable();
      // this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
      //   .get('ClientImp').disable();
      // this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
      //   .get('MitigationComment').disable();
      // this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)]
      //   .get('chkList').disable();
    }
    else{
      this.fillColorFlag =0 ;
    }
    
    let chkColumns:any;

    if(!(DoAccManage==null||DoAccManage=="")){
      chkColumns="Data Exists";
      console.log("Checking for data in que1");
    }else{
      chkColumns="";
    }
    console.log("quant status after validating all if conditions");
    console.log(this.quantities().controls[this.indexExpanded].get('status').value);
    console.log("grCount after validating all if conditions"+this.grCount);
    console.log("rownum : "+rowNum);
    console.log("contArrLength : "+this.contArrLength);
    // if (this.contArrLength == this.grCount) {
    //   this.quantities().controls[this.indexExpanded].patchValue({
    //     status : 'Complete'
    //   })
    // }
        // Teperory Solution for Complete Status By Ujjwal  
      if (this.quantities().controls[this.indexExpanded].get('status').value == 'Complete'
        && this.contArrLength == this.grCount) {
        console.log("Status Complete: " + this.grCount + this.contArrLength);
        if (rowNum != 0) {
          this.quantities().controls[this.indexExpanded].patchValue({
            status: 'Complete'
          })
        }

      }
    // else 
    // if(this.contArrLength == this.grCount){
    //   console.log("setting status complete based on grCount" +this.grCount);
      
    //   if (rowNum != 0) {
    //     this.quantities().controls[this.indexExpanded].patchValue({
    //       status: 'Complete'
    //     })
    //   }
    // }
    else if(chkColumns=="" && this.quantities().controls[this.indexExpanded].get('status').value!='In Progress'){
      if(this.quantities().controls[this.indexExpanded].get('status').value!='Complete'){
        console.log("STATUS: NOT STARTED");
        if (rowNum != 0)
        this.quantities().controls[this.indexExpanded].patchValue({
          status : 'Not Started'
        })
      }
    }
    else{
      console.log("Conditions Not listed in Excel");
      if (rowNum != 0)
      this.quantities().controls[this.indexExpanded].patchValue({
        status : 'In Progress'
      })

      /*
        if (rowNum == 0)
          this.quantities().controls[this.indexExpanded].patchValue({
            status: 'Not Started'
          })

        var selectedElement = element.id;
        console.log("const data : " + selectedElement.includes("ClientImp"))

        if (this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)].get("client").value == "Template"
          && rowNum == 0 && ClientImp != null)
          this.contractsmethod(this.indexExpanded).controls[0].patchValue({
            ClientImp: ClientImp
          });

        if (selectedElement.includes("ClientImp") && rowNum != 0 && ClientImp != null)
          this.contractsmethod(this.indexExpanded).controls[Number.toString().substring(this.indexExpanded.toString().length, Number.toString().length)].patchValue({
            ClientImp: ClientImp
          });
          **/

    }

    /*below section for recalling this method in case inbetween row num changed **/
    let ConValC : Array<IUpdateContract> =[];
      let checkingLength = 0;
      let rCall = false;
      if(rowNum != 0){
        for (let k = 1; k < this.quantities().controls[this.indexExpanded].get("contracts_array").value.length; k++) {

          if (this.contractsmethod(this.indexExpanded).controls[k].value.chkList)
            checkingLength++;
        }
  
        if(!this.contractsmethod(this.indexExpanded).controls[rowNum].value.chkList){
          rCall = true;
        }
  console.log("element data : "+element.id);
  var constEleID = element.id;
  var constEleValue = element.value;
  console.log("const data : "+constEleID.includes("ClientImp"))

      // if((rowNum <= this.contArrLength) && checkingLength > 0 && rCall && constEleID.includes("ClientInf")){
        // if((rowNum <= this.contArrLength) && checkingLength > 0 && rCall && constEleID.includes("ClientImp")){
        if ((rowNum <= this.contArrLength) && checkingLength > 0 && rCall) {
          this.grCheckCount = 0;
          if ((constEleValue == "No" && (constEleID.includes("DoAccManage") || constEleID.includes("ImpactedVersion"))) || constEleID.includes("ClientImp")) {
            for (let jk = 0; jk < this.quantities().controls[this.indexExpanded].get("contracts_array").value.length; jk++) {
              var ConValdata = new IUpdateContract();
              this.grCheckFlag = false;
              ConValdata.contract = this.contractsmethod(this.indexExpanded).controls[jk].get("contract").value;
              ConValdata.remediationraised = this.contractsmethod(this.indexExpanded).controls[jk].get("remediationraised").value;
              //ConValdata.DoAccManage = this.contractsmethod(index).controls[j].get("DoAccManage").value;
              ConValdata.DoAccManage = (this.contractsmethod(this.indexExpanded).controls[jk].get("DoAccManage").value == null) ? null : this.contractsmethod(this.indexExpanded).controls[jk].get("DoAccManage").value;
              ConValdata.ImpactedVersion = this.contractsmethod(this.indexExpanded).controls[jk].get("ImpactedVersion").value;
              ConValdata.AppliedCorrAction = this.contractsmethod(this.indexExpanded).controls[jk].get("AppliedCorrAction").value;
              ConValdata.ClientAppExcep = this.contractsmethod(this.indexExpanded).controls[jk].get("ClientAppExcep").value;
              // ConValdata.ClientInf = this.contractsmethod(this.indexExpanded).controls[jk].get("ClientInf").value;
              ConValdata.ClientInf = null;
              ConValdata.ClientImp = this.contractsmethod(this.indexExpanded).controls[jk].get("ClientImp").value;
              ConValdata.CommentAct = this.contractsmethod(this.indexExpanded).controls[jk].get("CommentAct").value;
              ConValdata.MitigationComment = this.contractsmethod(this.indexExpanded).controls[jk].get("MitigationComment").value;
              ConValdata.ContractVulStatus = "";

              ConValC.push(ConValdata);
              console.log("into chk change loop C :");
              console.log(ConValC[jk]);

              //&& jk != rowNum
              if (this.contractsmethod(this.indexExpanded).controls[jk].get("client").value != "Template") {

                // if ((ConVal[j].DoAccManage != "" || ConVal[j].ImpactedVersion != "" || ConVal[j].AppliedCorrAction != "" || ConVal[j].remediationraised != "" ||
                //   ConVal[j].ClientAppExcep != "" || ConVal[j].ClientInf != "" || ConVal[j].ClientImp != "")
                //   && (ConVal[j].DoAccManage != null || ConVal[j].ImpactedVersion != null || ConVal[j].AppliedCorrAction != null || ConVal[j].remediationraised != null ||
                //     ConVal[j].ClientAppExcep != null || ConVal[j].ClientInf != null || ConVal[j].ClientImp != null)) {
                console.log("in CC call ");
                console.log(this.indexExpanded);
                console.log(jk);
                console.log(ConValC[jk]);
                this.checkchangecommaction("DoAccManage" + this.indexExpanded + jk, ConValC[jk].DoAccManage);
                this.checkchangecommaction("ImpactedVersion" + this.indexExpanded + jk, ConValC[jk].ImpactedVersion);
                this.checkchangecommaction("AppliedCorrAction" + this.indexExpanded + jk, ConValC[jk].AppliedCorrAction);
                this.checkchangecommaction("remediationraised" + this.indexExpanded + jk, ConValC[jk].remediationraised);
                this.checkchangecommaction("ClientAppExcep" + this.indexExpanded + jk, ConValC[jk].ClientAppExcep);
                this.checkchangecommaction("ClientImp" + this.indexExpanded + jk, ConValC[jk].ClientImp);
                // this.checkchangecommaction("ClientInf" + this.indexExpanded + jk, ConValC[jk].ClientInf);

                // }

              }

            }
          }

        }

      }
      
      
        }


  getUserViewData(FilterData: any) {
    this.spinner.show();
    this.service.getVulnerabilityUserView(FilterData).subscribe(
      (data: any) => {
        this.productForm.setControl("quantities", this.SetQtyValue(data));
        this.spinner.hide();
        console.log("Viewdata");
        console.log(data);
      }
    )
  }

  setUserContractData(FilterData: any){
    this.contFill= 1;
     this.spinner.show();
    this.service.getVulnerabilityUserViewContract(FilterData).subscribe(
      (data: any) => {
        this.contData = data;
        this.productForm.setControl("quantities", this.SetQtyValue(data));
         this.spinner.hide();
      }
    );
  }

  calculateDiffdate(date: string,toCompareDate : string){
    /*
    let d2: Date = new Date();
    let d1 = Date.parse(date); //time in milliseconds
    var timeDiff = d2.getTime() - d1;
    var diff = timeDiff / (1000 * 3600 * 24);
    console.log("data diff "+diff);
    console.log(Math.floor(diff));
    return Math.floor(diff);
    **/
    let dateGot = new Date(date);
    let currentDate = new Date(toCompareDate);

    console.log("Date : "+date);
    console.log("rem date"+dateGot.getDate());
    console.log("rem month"+dateGot.getMonth());
    console.log("rem date"+dateGot.getFullYear());
    console.log("date got : "+dateGot);
    console.log("toCompareDate got "+ currentDate.getFullYear());
    console.log("toCompareDate date : "+ currentDate.getDate() );
    console.log("toCompareDate date month : "+ currentDate.getMonth() );
    console.log( currentDate.getMonth() + 1 );
    
    let remMnth = dateGot.getMonth() +1 ;
    let remDate = (Number.isNaN(dateGot.getDate()))? (dateGot.getDate() +"-"+remMnth +"-"+dateGot.getFullYear()) : date;
    console.log("remDate " + remDate);
    let remDate1 = new Date(remDate);
    let currMonth = currentDate.getMonth() + 1;
    let currDate = currentDate.getDate() +"-"+ currMonth +"-"+currentDate.getFullYear();
    console.log("remDate 1 : "+remDate1);
    console.log("cure date : "+currDate);
    let recDate = moment( (remDate.length != 10)? remDate1 : remDate,'DD-MM-YYYY');
    let newCurrDate = moment(currDate,'DD-MM-YYYY');
    console.log("recDate");
    console.log(recDate);
    console.log(newCurrDate);
    console.log("calc days ");
    console.log(recDate.diff(newCurrDate,'days'));
    //return newCurrDate.diff(recDate,'days');
    return recDate.diff(newCurrDate,'days');
}

calculateDiffdatewithCurrDate(date: string){
  /*
  let d2: Date = new Date();
  let d1 = Date.parse(date); //time in milliseconds
  var timeDiff = d2.getTime() - d1;
  var diff = timeDiff / (1000 * 3600 * 24);
  console.log("data diff "+diff);
  console.log(Math.floor(diff));
  return Math.floor(diff);
  **/
  let dateGot = new Date(date);
  let currentDate = new Date();

  console.log("Date : "+date);
  console.log("rem date"+dateGot.getDate());
  console.log("rem month"+dateGot.getMonth());
  console.log("rem date"+dateGot.getFullYear());
  console.log("date got : "+dateGot);
  console.log("toCompareDate got "+ currentDate.getFullYear());
  console.log("toCompareDate date : "+ currentDate.getDate() );
  console.log("toCompareDate date month : "+ currentDate.getMonth() );
  console.log( currentDate.getMonth() + 1 );
  
  let remMnth = dateGot.getMonth() +1 ;
  let remDate = (Number.isNaN(dateGot.getDate()))? (dateGot.getDate() +"-"+remMnth +"-"+dateGot.getFullYear()) : date;
  console.log("remDate " + remDate);
  let remDate1 = new Date(remDate);
  let currMonth = currentDate.getMonth() + 1;
  let currDate = currentDate.getDate() +"-"+ currMonth +"-"+currentDate.getFullYear();
  console.log("remDate 1 : "+remDate1);
  console.log("cure date : "+currDate);
  let recDate = moment( (remDate.length != 10)? remDate1 : remDate,'DD-MM-YYYY');
  let newCurrDate = moment(currDate,'DD-MM-YYYY');
  console.log("recDate");
  console.log(recDate);
  console.log(newCurrDate);
  console.log("calc days ");
  console.log(recDate.diff(newCurrDate,'days'));
  //return newCurrDate.diff(recDate,'days');
  return recDate.diff(newCurrDate,'days');
}

  InitialArray(){
    let i,j;
    let FormCount =this.productForm.get('quantities').value?.length || 0
    for(i=0;i<FormCount;i++)
    {
      let ContractCount =this.productForm.get(['quantities',i, 'contracts_array']).value?.length || 0
      
      for(j=0;j<ContractCount;j++)
      {
        
        let element1 = {id:"",value:""};                   
        let remediationdate_value= this.convert(this.productForm.get(['quantities', i, 'contracts_array',j,'remediationraised']).value); 
        element1.id="RemediationDate"+i+j
        element1.value=remediationdate_value
        
        if(this.cart.length>0){          
          let checkexist=0;
        for (let i = 0; i < this.cart.length; i++) {
          if(this.cart[i].id == element1.id) {
            this.cart[i].value = element1.value;  
            checkexist=1;
          }         
        }
        if(checkexist==0){this.cart.push(element1)}
      }
      else{        
        this.cart.push(element1);        
      }  
      
      let element2 = {id:"",value:""};  
        let DoAccManage_value=this.productForm.get(['quantities', i, 'contracts_array',j,'DoAccManage']).value;
        element2.id="DoAccManage"+i+j
        element2.value=DoAccManage_value
        if(this.cart.length>0){
          let checkexist=0;
        for (let i = 0; i < this.cart.length; i++) {
          if(this.cart[i].id == element2.id) {
            this.cart[i].value = element2.value;  
            checkexist=1;
          }         
        }
        if(checkexist==0){this.cart.push(element2)}
      }
      else{this.cart.push(element2);}      

      let element3 = {id:"",value:""};
        let AppliedCorrAction_value=this.productForm.get(['quantities', i, 'contracts_array',j,'AppliedCorrAction']).value;
        element3.id="AppliedCorrAction"+i+j
        element3.value=AppliedCorrAction_value
        if(this.cart.length>0){
          let checkexist=0;
        for (let i = 0; i < this.cart.length; i++) {
          if(this.cart[i].id == element3.id) {
            this.cart[i].value = element3.value;  
            checkexist=1;
          }         
        }
        if(checkexist==0){this.cart.push(element3)}
      }
      else{this.cart.push(element3);}

      let element4 = {id:"",value:""};
        let ClientAppExcep_value=this.productForm.get(['quantities', i, 'contracts_array',j,'ClientAppExcep']).value;
        element4.id="ClientAppExcep"+i+j
        element4.value=ClientAppExcep_value
        if(this.cart.length>0){
          let checkexist=0;
        for (let i = 0; i < this.cart.length; i++) {
          if(this.cart[i].id == element4.id) {
            this.cart[i].value = element4.value;  
            checkexist=1;
          }         
        }
        if(checkexist==0){this.cart.push(element4)}
      }
      else{this.cart.push(element4);}

      let element5 = {id:"",value:""};
        let ClientInf_value=this.productForm.get(['quantities', i, 'contracts_array',j,'ClientInf']).value;
        element5.id="ClientInf"+i+j
        element5.value=ClientInf_value
        if(this.cart.length>0){
          let checkexist=0;
        for (let i = 0; i < this.cart.length; i++) {
          if(this.cart[i].id == element5.id) {
            this.cart[i].value = element5.value;  
            checkexist=1;
          }         
        }
        if(checkexist==0){this.cart.push(element5)}
      }
      else{this.cart.push(element5);}

      let element6 = {id:"",value:""};
        let ClientImp_value=this.productForm.get(['quantities', i, 'contracts_array',j,'ClientImp']).value;
        element6.id="ClientImp"+i+j
        element6.value=ClientImp_value
        if(this.cart.length>0){
          let checkexist=0;
        for (let i = 0; i < this.cart.length; i++) {
          if(this.cart[i].id == element6.id) {
            this.cart[i].value = element6.value;  
            checkexist=1;
          }         
        }
        if(checkexist==0){this.cart.push(element6)}
      }
      else{this.cart.push(element6);}
        
      }      
      
    }
  
  }
  
  onSubmit(event:any,IsDelegated:any){
    
    // console.log("This is to check the popup")
    // this.confirmDialog();
    

//#region 
    let Checked = 0;     
 this.InitialArray();
 let DoAccManage=""
 ,AppliedCorrAction=""
 ,ClientAppExcep=""
 ,ClientInf=""
 ,ClientImp=""    
 var target = event.target || event.srcElement || event.currentTarget;
 this.idAttr = target.attributes.id;
 var value = this.idAttr.nodeValue;
 let myArray:any [] = value.split(/([0-9]+)/)
let Id= myArray[0]
let FirstNumber=myArray[1]      
let ContractCount =this.productForm.get(['quantities',FirstNumber, 'contracts_array']).value?.length || 0  
let k;
for(k=0;k<ContractCount;k++)
{
   for (let j = 0; j < this.cart.length; j++) {
     if(this.cart[j].id =="DoAccManage"+FirstNumber+k ) {
       DoAccManage=this.cart[j].value;       
     }
     if(this.cart[j].id =="AppliedCorrAction"+FirstNumber+k ) {
       AppliedCorrAction=this.cart[j].value;       
     }
     if(this.cart[j].id =="ClientAppExcep"+FirstNumber+k ) {
       ClientAppExcep=this.cart[j].value;       
     }
     if(this.cart[j].id =="ClientInf"+FirstNumber+k ) {
       ClientInf=this.cart[j].value;       
     }
     if(this.cart[j].id =="ClientImp"+FirstNumber+k ) {
       ClientImp=this.cart[j].value;       
     }        
   }
   if(DoAccManage=="")
    {
    alert("Please fill the Question 1");Checked=1;break;
    }    
   else if ((DoAccManage=="Yes")&&(AppliedCorrAction==""))
    {
     alert("Please fill the Question 2");Checked=1;break;
    }
    else if (((DoAccManage=="Yes")||(DoAccManage=="No"))&&ClientAppExcep=="")
    {
     alert("Please fill the Question 4");Checked=1;break;
    }              
   if(ClientInf =="")
   {
     alert("Please fill the Question 5");Checked=1;break;
   }

 }
//#endregion

if(this.quantities().controls[this.indexExpanded].get("Delegate_array").value.length == 0 && IsDelegated){
  alert("Please select delegate");
  Checked=1;
}

if (Checked==0) {
  this.UpdateUserView(IsDelegated);
}
    
  }
  
  UnlockBlock(event:any){
    console.log("Unlock block")
    
    var target = event.target || event.srcElement || event.currentTarget;
    var idAttr = target.attributes.id;
    var value = idAttr.nodeValue;
    //console.log(value);
    //console.log("test loop"+this.quantities().controls[value].get("contracts_array").value.length)
    for (let v=0; v < this.quantities().controls[value].get("contracts_array").value.length; v++) {
      console.log("inside unlock loop")
      console.log(this.contractsmethod(value).controls[v].get("remediationraised").value);
       this.contractsmethod(value).controls[v].get("remediationraised").enable();
       this.contractsmethod(value).controls[v].get("DoAccManage").enable();
       this.contractsmethod(value).controls[v].get("ImpactedVersion").enable();
       this.contractsmethod(value).controls[v].get("AppliedCorrAction").enable();
       this.contractsmethod(value).controls[v].get("ClientAppExcep").enable();
       this.contractsmethod(value).controls[v].get("ClientInf").enable();
       this.contractsmethod(value).controls[v].get("ClientImp").enable();  
       this.Hidebtn=false;    
    }
    alert("Contracts Unlocked Successfully!!");
}

disableDelButton(indexVal : number){
  
  if(this.quantities().controls[indexVal].get("Delegate_array").value.length <=0 ){
    this.delFlag = true;
  }
  else{
    this.delFlag = false;
  }

  return this.delFlag;
}

  UpdateUserView(IsDelegated: any) {
    let delegatecheck = true
    let ConVal: Array<IUpdateContract> = [];
    let DelVal: Array<Delegate> = [];
    let DelValSelectedCnt = 0;
    for (let i = this.idAttr.nodeValue; i < this.productForm.controls['quantities'].value.length; i++) {
      //#region Delegate

      for (let j = 0; j < this.quantities().controls[i].get("Delegate_array").value.length; j++) {
        var DelValdata = new Delegate();
        DelValdata.UpdateContracts = (this.delegatemethod(i).controls[j].get("contractnumber").value).toString();
        DelValdata.UpdateDelegates = this.delegatemethod(i).controls[j].get("delegates").value;
        if (DelValdata.UpdateContracts == "" || DelValdata.UpdateContracts == null || DelValdata.UpdateDelegates == "" || DelValdata.UpdateDelegates == null) {
          delegatecheck = false;
          alert("Please fill all fields for delegate!")
        }
        DelVal.push(DelValdata);
      }
      console.log("ActualDelSelCheck length on save : "+this.ActualDelSelCheck);
      DelValSelectedCnt = DelVal.length + DelValSelectedCnt;
      console.log("DelValSelectedCnt length on save : "+DelValSelectedCnt);

      if(DelValSelectedCnt > this.ActualDelSelCheck){
        IsDelegated = true;
      }
      //#endregion Delegate
      for (let j = 0; j < this.quantities().controls[i].get("contracts_array").value.length; j++) {
        var ConValdata = new IUpdateContract();
        // var contractParts = this.contractsmethod(i).controls[j].get("contract_name").value.split("/");
        ConValdata.contract = this.contractsmethod(i).controls[j].get("contract").value;
        // ConValdata.contract = contractParts[0];
        ConValdata.remediationraised = (this.contractsmethod(i).controls[j].get("remediationraised").value != null) ? this.convert(this.contractsmethod(i).controls[j].get("remediationraised").value) : null;
        console.log("Remediation date raised value on userview :" + ConValdata.remediationraised);
        ConValdata.DoAccManage = this.contractsmethod(i).controls[j].get("DoAccManage").value;
        ConValdata.ImpactedVersion = this.contractsmethod(i).controls[j].get("ImpactedVersion").value;
        ConValdata.AppliedCorrAction = this.contractsmethod(i).controls[j].get("AppliedCorrAction").value;
        ConValdata.ClientAppExcep = this.contractsmethod(i).controls[j].get("ClientAppExcep").value;
        ConValdata.ClientInf = this.contractsmethod(i).controls[j].get("ClientInf").value;
        ConValdata.ClientImp = this.contractsmethod(i).controls[j].get("ClientImp").value;
        ConValdata.CommentAct = this.setCommentActValue(ConValdata.DoAccManage, ConValdata.AppliedCorrAction, ConValdata.ClientAppExcep, ConValdata.ClientInf, ConValdata.remediationraised, ConValdata.ClientImp, this.quantities().controls[i].get("dateraised").value);
        ConValdata.MitigationComment = this.contractsmethod(i).controls[j].get("MitigationComment").value;
        ConValdata.chkList = (this.contractsmethod(i).controls[j].get("chkList").value) ? 1 : 0;

        // ConValdata.ContractVulStatus = "";
        ConValdata.ContractVulStatus = this.setContractStatusValue(ConValdata.DoAccManage, ConValdata.ImpactedVersion, ConValdata.AppliedCorrAction,
          ConValdata.ClientAppExcep, ConValdata.ClientInf, ConValdata.remediationraised, ConValdata.ClientImp,
          this.quantities().controls[i].get("dateraised").value)
        // ConValdata  = [{
        //     contract:this.contractsmethod(i).controls[j].get("contract").value,               
        //     remediationraised: this.contractsmethod(i).controls[j].get("remediationraised").value,
        //     DoAccManage  : this.contractsmethod(i).controls[j].get("DoAccManage").value,
        //     AppliedCorrAction : this.contractsmethod(i).controls[j].get("AppliedCorrAction").value,
        //     ClientAppExcep : this.contractsmethod(i).controls[j].get("ClientAppExcep").value,
        //     ClientInf : this.contractsmethod(i).controls[j].get("ClientInf").value,
        //     ClientImp : this.contractsmethod(i).controls[j].get("ClientImp").value,
        //     CommentAct : this.contractsmethod(i).controls[j].get("CommentAct").value
        // }];
        console.log("Prev data submit");
        console.log(this.ContPrevData);
        if(this.ContPrevData[j].DoAccManage != ConValdata.DoAccManage || this.ContPrevData[j].ImpactedVersion != ConValdata.ImpactedVersion
          || this.ContPrevData[j].AppliedCorrAction != ConValdata.AppliedCorrAction || this.ContPrevData[j].ClientAppExcep != ConValdata.ClientAppExcep
          || this.ContPrevData[j].ClientImp != ConValdata.ClientImp ){
            ConVal.push(ConValdata);
          }
      }

      const notAnyContract = this.appliedColor == "grey"? "Yes" :"No";
      var val = {
        VID: this.quantities().controls[i].get("VID").value,
        deligate: this.quantities().controls[i].get("deligate").value,
        deliveryteamcomment: this.quantities().controls[i].get("deliveryteamcomment").value,
        status: this.quantities().controls[i].get("status").value,
        LastUpdatedBy: this.Eid,
        contracts_array: ConVal,
        Delegate_array: DelVal,
        IsDelegated: IsDelegated,
        notAnyContract : notAnyContract
      }
      break;
    }
    if (delegatecheck) {
      this.spinner.show();
      this.service.UpdateVulUserView(val).subscribe(res => {
        alert(res.toString());
        this.indexExpanded = -1;
        this.refreshData();
        this._router.navigate([this._router.url]);
        this.spinner.hide();
      });
    }
  }
  refreshData(){
    var FilterData = {
      UserID : this.Eid     
  }
  this.spinner.show();
    this.service.getVulnerabilityUserView(FilterData).subscribe(
      (data : any)=>{
        this.productForm.setControl("quantities", this.SetQtyValue(data));
        this.spinner.hide();
      }
    )
  }

  setCommentActValue(AccManage : string,CorApp : string,appException : string,clientInformed : string,remediationraised : string,
    clientImp : string,dateRaised : string){
    let strCommAct = "";
console.log("set comment act ");
console.log(remediationraised);
let dateDiff ;
let CurrentDate = moment().format("DD-MM-YYYY");
let SplitCurrentDate =CurrentDate.split("-")

let raisedDateVal = remediationraised;
let SplitDate;
if(raisedDateVal != null){
  console.log("calling calculate");
  dateDiff = this.calculateDiffdate(raisedDateVal,dateRaised);
  SplitDate=raisedDateVal.split("-");
}else{
  SplitDate="aN";
}

//let SplitDate= (raisedDateVal!=null)? raisedDateVal.split("-") : "aN";

if(SplitDate.length == 1){
  if((SplitDate[1]=="aN"))
  {
  let dateString = remediationraised;
  var allDate = dateString.split(':');
  var thisDate = allDate[0].split('-');
  var thisTime = allDate[1].split(':');
  var newDate = [thisDate[2].slice(0,2),thisDate[1],thisDate[0] ].join("-");
  let newDate_Array=newDate.split("-");
  SplitDate=newDate_Array;
  }
}

let Today_Date_Check=0;
// for(i=0;i<3;i++)
// {
  if(SplitCurrentDate[0]==SplitDate[0] && SplitCurrentDate[1]==SplitDate[1] && SplitCurrentDate[2]==SplitDate[2])
{
  Today_Date_Check++;
}

let dateCompare: number;
let remediationraisedVal = remediationraised;

if(remediationraisedVal != null ){
  console.log("calling calculate remediationraisedVal");
  dateCompare = this.calculateDiffdatewithCurrDate(remediationraisedVal);
}

    if(AccManage=="No" &&
    (CorApp=="" || CorApp== null)&&
  Today_Date_Check == 0 &&
  (appException=="" || appException == null)&&
  (clientInformed=="Yes"|| clientInformed=="N/A"))  
  { 
    strCommAct="Please inform the client about the vulnerability and recommended actions";
    
  }
  else if( AccManage=="Yes"&&
  CorApp=="Yes"&&
  Today_Date_Check>0&&
  appException==""&&
  clientInformed=="Yes")
  {  
    console.log("came here5");  
    strCommAct="Thank you for protecting Accenture and our clients";
  }
  else if(AccManage=="No"&&
  CorApp=="No"&&
  //SplitDate=="aN"&&
  appException=="Yes"&&
  (clientInformed=="Yes"|| clientInformed=="N/A"))
  {    
    strCommAct="The GCC will contact you for details of the exception";
  }
  else if(AccManage=="Yes"&&
  CorApp=="No"&&
  // SplitDate[0]=="21"&& SplitDate[1]=="07"&&  SplitDate[2]=="2021"&&
  appException=="No"&&
  clientInformed=="Yes")
  {    
    strCommAct="This date is later than 14 days from detection and will be reported to leadership";
  }
  // else if(AccManage=="Yes"&&
  // CorApp=="No"&&
  // //SplitDate[0]=="21"&& SplitDate[1]=="05"&& SplitDate[2]=="2021"&&
  // appException=="Yes"&&
  // clientInformed=="Yes")
  // {    
  //   strCommAct="The GCC will contact you for details of the exception";
  // }
  else if(AccManage=="Yes"&&
  CorApp=="No"&&
  //SplitDate[0]=="30"&& SplitDate[1]=="04"&& SplitDate[2]=="2021"&&
  appException=="No"&&
  clientInformed=="Yes")
  {    
    strCommAct="Date has passed, please provide an update";
  }
  else if(AccManage == "Yes" && CorApp == "Yes" && clientInformed =="Yes" && clientImp =="Yes" ){
    strCommAct="Has the Client environment been scanned for malicious activity";
  }
  else if(AccManage=="No" &&
(CorApp==null)&&
  Today_Date_Check == 0 &&
  (appException==null)&&
  (clientInformed=="Yes")&&
  (clientImp=="No"))  {
    strCommAct = "No Action required";
  }
  else if(AccManage=="No" &&
(CorApp==null)&&
  Today_Date_Check == 0 &&
  (appException==null)&&
  (clientInformed=="Yes")&&
  (clientImp=="Yes"))  {
    strCommAct = "Evaluate if Accenture scope services are impacted and has the client environment been scanned for malicious activity";
  }
//   else if(AccManage=="Yes" &&
// (CorApp== "No")&&
//   Today_Date_Check == 0 &&
//   (appException== "Yes")&&
//   (clientInformed=="Yes")&&
//   (clientImp=="Yes" ))  {
//     strCommAct = "Please inform the client about the vulnerability and recommended actions";
//   }
  else if (AccManage == "Yes" &&
  (CorApp == "No") &&
  Today_Date_Check > 0 && dateDiff < 14 &&
  (appException == "Yes") &&
  (clientInformed == "Yes") && clientImp == "Yes") {
  strCommAct = "Share the approved exception details with GCC and has the Client environment been scanned for malicious activity ";
  
}
else if (AccManage == "Yes" &&
  (CorApp == "No") &&
  Today_Date_Check > 0 && dateDiff < 14 &&
  (appException == "Yes") &&
  (clientInformed == "Yes") && clientImp == "No") {
  strCommAct = "Share the approved exception details with GCC. Please update the status once remediation actions are complete";
  
}
else if (AccManage == "Yes" &&
  (CorApp == "No") &&
  (dateDiff > 0 && dateDiff < 14) &&
  (appException == "No" || appException == "N/A") &&
  (clientInformed == "Yes") && clientImp == "Yes") {
  strCommAct = "Has the Client environment been scanned for malicious activity?";
  
}
else if (AccManage == "Yes" &&
  (CorApp == "No") &&
  (dateDiff > 0 && dateDiff < 14) &&
  (appException == "No" || appException == "N/A") &&
  (clientInformed == "Yes") && clientImp == "No") {
  strCommAct = "Please update the status once remediation actions are complete";
  
}
else if (AccManage == "Yes" &&
  (CorApp == "Yes") &&
  Today_Date_Check >0 &&
  (appException == null || appException == "N/A") &&
  (clientInformed == "Yes") && clientImp == "No") {
  strCommAct = "Thank you for protecting Accenture and our clients";
  
}
else if (AccManage == "Yes" &&
  (CorApp == "Yes") &&
  Today_Date_Check ==0 &&
  (appException == null ) &&
  (clientInformed == "Yes") && clientImp == "No") {
  strCommAct = "Thank you for protecting Accenture and our clients";
  
}
else if (AccManage == "Yes" &&
  (CorApp == "No") &&
  dateDiff >= 14 &&
  (appException == "No" ) &&
  (clientInformed == "Yes") && clientImp == "Yes") {
  strCommAct = "This date is later than 14 days from detection and will be reported to leadership.\n Has the Client environment been scanned for malicious activity? \n Raise a CDP exception request";
  
}
else if (AccManage == "Yes" &&
  (CorApp == "No") &&
  dateDiff >= 14 &&
  (appException == "No" ) &&
  (clientInformed == "Yes") && clientImp == "No") {
  strCommAct = "This date is later than 14 days from detection and will be reported to leadership  \n Raise a CDP exception request";
  
}
else if (AccManage == "Yes" &&
  (CorApp == "No") && dateDiff >= 14 && appException == "Yes" &&
  (clientInformed == "Yes") && clientImp == "Yes") {
  strCommAct = "This date is later than 14 days from detection and will be reported to leadership. \n Share the approved exception details with GCC \n Has the Client environment been scanned for malicious activity?";
  
}
else if (AccManage == "Yes" &&
  (CorApp == "No") && dateDiff >= 14 && appException == "Yes" &&
  (clientInformed == "Yes") && clientImp == "No") {
  strCommAct = "This date is later than 14 days from detection and will be reported to leadership. Share the approved exception details with GCC";
  
}
else if (AccManage == "Yes" &&
  (CorApp == "No") && Today_Date_Check == 0 && appException == "Yes" &&
  (clientInformed == "Yes") && clientImp == "No") {
  strCommAct = "Share the approved exception details with GCC";
  
}
else if (AccManage == "Yes" &&
  (CorApp == "No") && Today_Date_Check == 0 && appException == "Yes" &&
  (clientInformed == "Yes") && clientImp == "No") {
  strCommAct = "Share the approved exception details with GCC";
}
else if (AccManage == "Yes" &&
  (CorApp == "No") && (appException == "No" || appException == "N/A") &&
  (clientInformed == "Yes") && (clientImp == "No" || clientImp == "Yes") && dateCompare < 0) {
  strCommAct = "Date has passed, please provide an update";
}
else if (AccManage == "Yes" &&
  (CorApp == "No") && (appException == "Yes") &&
  (clientInformed == "No") && (clientImp == "No" || clientImp == "Yes") && dateCompare < 0) {
  strCommAct = "Share the approved exception details with GCC and notify the client about vulnerability";
}
else if (AccManage == "Yes" &&
  (CorApp == "No") && (appException == "Yes") &&
  (clientInformed == "Yes") && (clientImp == "Yes") && Today_Date_Check==0) {
  strCommAct = "Share the approved exception with GCC, has the Client environment been scanned for malicious activity?";
}
else if (AccManage == "Yes" &&
  (CorApp == "No") && (appException == "No") &&
  (clientInformed == "No") && (clientImp == "No") && Today_Date_Check==0) {
  strCommAct = "Share the remediation date and notify the client about vulnerability";
}
  else
  {
    strCommAct=""; 
  }
    return strCommAct;
  }

  setContractStatusValue(AccManage : string,ImpactedVs:string,CorApp : string,appException : string,clientInformed : string,remediationraised : string
    ,clientImpacted : string,dateraised : string){
      let Constatus = "";
    let raisedDateVal = remediationraised;
    
    let dateDiff = 0;
    
    
    if (raisedDateVal!=null) {
      console.log("calculate difference between remediation date and raised date");
      console.log("remediation Date: "+raisedDateVal);
      console.log("date Raised: "+dateraised);
      dateDiff = this.calculateDiffdate(raisedDateVal, dateraised);
    }

    let dateCompare: number;
    let remediationraisedVal = remediationraised;
    
    if (remediationraisedVal != null) {      
      dateCompare = this.calculateDiffdatewithCurrDate(remediationraisedVal);
    }

    /* New contract status formation**/
    if(AccManage == "No" && ImpactedVs == null && CorApp == null && raisedDateVal == null && appException == null && clientImpacted == null)
    {
      Constatus = "Complete";
      /* commented on 3rd Jul 24
      if(clientInformed == "Yes"){
        Constatus = "Complete";
      }
      else if(clientInformed == "No"){
        Constatus = "In Progress";
      }
      */
    }

    if(AccManage == "Yes" && ImpactedVs == null && CorApp == null && raisedDateVal == null && appException == null && clientImpacted == null)
    {
      Constatus = "In Progress";
      
    }

    if(AccManage == "Yes" && ImpactedVs == "No" && CorApp == null && raisedDateVal == null && appException == null && clientImpacted == null)
    {
      Constatus = "Complete";
      /* commented on 3rd Jul 24
      if(clientInformed == "Yes"){
        Constatus = "Complete";
      }
      else if(clientInformed == "No"){
        Constatus = "In Progress";
      }
      */
    }

    if(AccManage == "Yes" && ImpactedVs == "Yes" && CorApp == null && raisedDateVal == null && appException == null && clientImpacted == null)
    {
      Constatus = "In Progress";
    }

    if(AccManage == "Yes" && ImpactedVs == "Yes" && appException == "Yes" && CorApp == null && raisedDateVal == null && clientImpacted == null)
    {
      Constatus = "In Progress";//row 5
    }

    if(AccManage == "Yes" && ImpactedVs == "Yes" && appException == "Yes" && CorApp == null && raisedDateVal == null )
    {
      Constatus = clientImpacted == "Yes" ? "Complete" : "Risk Validation";
      //Constatus = "Complete";
    }

    if(AccManage == "Yes" && ImpactedVs == "Yes" && (CorApp == "Patch applied" || CorApp == "Workaround applied") 
        && raisedDateVal == null && (appException == "No" || appException == "N/A") )
    {
      if(clientImpacted == "Yes" ){
        Constatus = "Risk Validation";
      }
      else if((clientImpacted == "No" || clientImpacted == "N/A")){
        Constatus = "Complete";
      }
      
    }

    if(AccManage == "Yes" && ImpactedVs == "Yes" && CorApp == "No" 
         && (appException == "No" || appException == "N/A") )
    {
      if(clientImpacted == null && raisedDateVal == null){
        Constatus = "In Progress";
      }
      
    }

    if(AccManage == "Yes" && ImpactedVs == "Yes" && CorApp == "No" 
        && raisedDateVal != null && (appException == "No" || appException == "N/A") )
    {
      if(clientImpacted == "Yes" ){
        Constatus = "Risk Validation";
      }
      else if((clientImpacted == "No" || clientImpacted == "N/A") ){
        Constatus = "In Progress";
      }
      
    }


    if((Constatus == null || Constatus == "") 
    && this.quantities().controls[this.indexExpanded].get('status').value == 'In Progress'){
      Constatus = "In Progress";
    }
    return Constatus;

        /* old contract status formation
    if (AccManage == "No" && ImpactedVs=="No" && CorApp == null &&  raisedDateVal== null && appException ==null) {
      if(clientInformed == "Yes"){
        if(clientImpacted == "No"){
          Constatus = "Complete";
        }
        else if(clientImpacted == "Yes"){
          Constatus = "Risk Validation";
        }
      }
      else if(clientInformed == "No"){
        if(clientImpacted == "Yes"){
          Constatus = "Risk Validation";
        }
        else if(clientImpacted == "No"){
          Constatus = "Complete";
        }
      }
     
    }

    if (AccManage == "Yes" && ImpactedVs=="No" && CorApp == null && raisedDateVal == null && appException == null) {
      if(clientInformed == "Yes"){
        if(clientImpacted == "No"){
          Constatus = "Complete";
        }
        else if(clientImpacted == "Yes"){
          Constatus = "Risk Validation";
        }
      }
      else if(clientInformed == "No"){
        if(clientImpacted == "Yes"){
          Constatus = "Risk Validation";
        }
        else if(clientImpacted == "No"){
          Constatus = "Complete";
        }
      }
    }
    if (AccManage == "Yes" && ImpactedVs=="Yes"){
      if(CorApp=="Yes"){
        if(raisedDateVal!=null && appException==null && clientInformed == "Yes" && clientImpacted == "No"){
          Constatus = "Complete";
        }
      }
      else if(CorApp == "No") {
        if(raisedDateVal==null){
          if(appException=="Yes"){
            if(clientInformed == "Yes" && clientImpacted == "No"){
              Constatus = "Risk Validation";
            }
            if(clientInformed == "Yes" && clientImpacted == "Yes"){
              Constatus = "Risk Validation";
            }
            if(clientInformed == "No" && clientImpacted == "Yes"){
              Constatus = "Risk Validation";
            }
            if(clientInformed == "No" && clientImpacted == "No"){
              Constatus = "Risk Validation";
            }
          }
          else if (appException=="No"){
            if(clientInformed == "Yes" && clientImpacted == "Yes"){
              Constatus = "Risk Validation";
            }
            if(clientInformed == "Yes" && clientImpacted == "No"){
              Constatus = "In Progress";
            }
            if(clientInformed == "No" && clientImpacted == "Yes"){
              Constatus = "Risk Validation";
            }
            if(clientInformed == "No" && clientImpacted == "No"){
              Constatus = "In Progress";
            }
          }
          else if(appException=="NA"){
            if(clientInformed == "Yes" && clientImpacted == "Yes"){
              Constatus = "Risk Validation";
            }
            if(clientInformed == "Yes" && clientImpacted == "No"){
              Constatus = "In Progress";
            }
            if(clientInformed == "No" && clientImpacted == "Yes"){
              Constatus = "Risk Validation";
            }
            if(clientInformed == "No" && clientImpacted == "No"){
              Constatus = "In Progress";
            }
          }
        }
        else if(raisedDateVal!=null && dateDiff < 14){
          if(appException=="Yes"){
            if(clientInformed == "Yes" && clientImpacted == "Yes"){
              Constatus = "Risk Validation";
            }
            if(clientInformed == "Yes" && clientImpacted == "No"){
              Constatus = "Risk Validation";
            }
            if(clientInformed == "No" && clientImpacted == "Yes"){
              Constatus = "Risk Validation";
            }
            if(clientInformed == "No" && clientImpacted == "No"){
              Constatus = "Risk Validation";
            }
          }
          else if(appException=="No"){
            if(clientInformed == "Yes" && clientImpacted == "Yes"){
              Constatus = "Risk Validation";
            }
            if(clientInformed == "Yes" && clientImpacted == "No"){
              Constatus = "In Progress";
            }
            if(clientInformed == "No" && clientImpacted == "Yes"){
              Constatus = "Risk Validation";
            }
            if(clientInformed == "No" && clientImpacted == "No"){
              Constatus = "In Progress";
            }
          }
        }
        else if(raisedDateVal!=null && dateDiff > 14){
          if(appException == "NA"){
            if(clientInformed == "Yes" && clientImpacted == "Yes"){
              Constatus = "Risk Validation";
            }
            if(clientInformed == "Yes" && clientImpacted == "No"){
              Constatus = "In Progress";
            }
          }
        }
        else if (dateCompare < 0 && (appException=="No" || appException=="NA") && clientInformed=="Yes" && (clientImpacted=="Yes" || clientImpacted== "No")){
          console.log("Triggering past due date on contractstatus");
          Constatus = "Past due date";
        }
      }
      else if (CorApp=="Workaround applied"){
        if(raisedDateVal==null){
          if(appException=="No"){
            if(clientInformed=="Yes" && clientImpacted=="No"){
              Constatus = "In Progress";
            }
            else if(clientInformed=="Yes" && clientImpacted=="Yes"){
              Constatus = "Risk Validation";
            }
          }
          else if(appException=="Yes"){
            if(clientInformed == "Yes" && clientImpacted=="No"){
              Constatus = "Risk Validation";
            }
            else if(clientInformed=="Yes" && clientImpacted=="Yes"){
              Constatus = "Risk Validation";
            }
            else if(clientInformed=="No" && clientImpacted=="No"){
              Constatus = "Risk Validation";
            }
            else if(clientInformed=="No" && clientImpacted=="Yes"){
              Constatus = "Risk Validation";
            }
          }
        }
        else if (raisedDateVal!=null && dateDiff < 14){
          if(appException=="No"){
            if(clientInformed=="Yes" && clientImpacted=="No"){
              Constatus = "In Progress";
            }
            else if(clientInformed=="Yes" && clientImpacted=="Yes"){
              Constatus = "Risk Validation";
            }
          }
          else if(appException=="Yes"){
            if(clientInformed == "Yes" && clientImpacted=="No"){
              Constatus = "Risk Validation";
            }
            else if(clientInformed=="Yes" && clientImpacted=="Yes"){
              Constatus = "Risk Validation";
            }
            else if(clientInformed=="No" && clientImpacted=="No"){
              Constatus = "Risk Validation";
            }
            else if(clientInformed=="No" && clientImpacted=="Yes"){
              Constatus = "Risk Validation";
            }
        }
        }
      }
      else if(CorApp=="Patch applied"){        
        if(raisedDateVal==null||raisedDateVal=="aN-aN-NaN"){
          if(appException=="No"){
            if(clientInformed=="Yes" && clientImpacted=="No"){
              Constatus = "In Progress";
            }
            else if(clientInformed=="Yes" && clientImpacted=="Yes"){
              Constatus = "Risk Validation";
            }
          }
          else if(appException=="Yes"){
            if(clientInformed == "Yes" && clientImpacted=="No"){
              Constatus = "Risk Validation";
            }
            else if(clientInformed=="Yes" && clientImpacted=="Yes"){
              Constatus = "Risk Validation";
            }
            else if(clientInformed=="No" && clientImpacted=="No"){
              Constatus = "Risk Validation";
            }
            else if(clientInformed=="No" && clientImpacted=="Yes"){              
              Constatus = "Risk Validation";
            }
          }
        }
        else if (raisedDateVal!=null && dateDiff < 14){
          if(appException=="No"){
            if(clientInformed=="Yes" && clientImpacted=="No"){
              Constatus = "Complete";
            }
            else if(clientInformed=="Yes" && clientImpacted=="Yes"){
              Constatus = "Risk Validation";
            }
          }
          else if(appException=="Yes"){
            if(clientInformed == "Yes" && clientImpacted=="No"){
              Constatus = "Risk Validation";
            }
            else if(clientInformed=="Yes" && clientImpacted=="Yes"){
              Constatus = "Risk Validation";
            }
            else if(clientInformed=="No" && clientImpacted=="No"){
              Constatus = "Risk Validation";
            }
            else if(clientInformed=="No" && clientImpacted=="Yes"){
              Constatus = "Risk Validation";
            }
        }
      }
    }
  }
**/
    // else if (AccManage == "Yes" &&
    //   (CorApp == "No") &&
    //   raisedDateVal > 0 && dateDiff < 14 &&
    //   (appException == "Yes") &&
    //   (clientInformed == "Yes") && clientImpacted == "Yes") {

    //   Constatus = "In Progress"
    // }
    // else if (AccManage == "Yes" &&
    //   (CorApp == "No") &&
    //   raisedDateVal > 0 && dateDiff < 14 &&
    //   (appException == "Yes") &&
    //   (clientInformed == "Yes") && clientImpacted == "No") {
      
    //   Constatus = "In Progress"
    // }
    // else if (AccManage == "Yes" &&
    //   (CorApp == "No") &&
    //   raisedDateVal > 0 && dateDiff < 14 &&
    //   (appException == "No" || appException == "N/A") &&
    //   (clientInformed == "Yes") && clientImpacted == "Yes") {
      
    //   Constatus = "In Progress"
    // }
    // else if (AccManage == "Yes" &&
    //   (CorApp == "No") &&
    //   raisedDateVal > 0 && dateDiff < 14 &&
    //   (appException == "No" || appException == "N/A") &&
    //   (clientInformed == "Yes") && clientImpacted == "No") {
      
    //   Constatus = "In Progress"
    // }
    // else if (AccManage == "Yes" &&
    //   (CorApp == "Yes") &&
    //   raisedDateVal == 0 &&
    //   (appException == null) &&
    //   (clientInformed == "Yes") && clientImpacted == "No") {
      
    //   Constatus = "Complete"
    // }
    // else if (AccManage == "Yes" &&
    //   (CorApp == "No") &&
    //   dateDiff > 14 &&
    //   (appException == "No") &&
    //   (clientInformed == "Yes") &&
    //   (clientImpacted == "Yes")) {
      
    //   Constatus = "In Progress"
    // }
    // else if (AccManage == "Yes" &&
    //   (CorApp == "No") &&
    //   dateDiff > 14 &&
    //   (appException == "No") &&
    //   (clientInformed == "Yes") &&
    //   (clientImpacted == "No")) {
      
    //   Constatus = "In Progress"
    // }
    // else if (AccManage == "Yes" &&
    //   (CorApp == "Yes") &&
    //   (clientInformed == "Yes") && clientImpacted == "Yes") {
      
    //   Constatus = "Risk validation"
    // }
    // else if (AccManage == "Yes" &&
    //   (CorApp == "No") &&
    //   dateDiff > 14 &&
    //   (appException == "Yes") &&
    //   (clientInformed == "Yes") &&
    //   (clientImpacted == "Yes")) {
      
    //   Constatus = "In Progress"
    // }
    // else if (AccManage == "Yes" &&
    //   (CorApp == "No") &&
    //   dateDiff > 14 &&
    //   (appException == "Yes") &&
    //   (clientInformed == "Yes") &&
    //   (clientImpacted == "No")) {
      
    //   Constatus = "In Progress"
    // }
    // else if (AccManage == "Yes" &&
    //   (CorApp == "No") &&
    //   raisedDateVal == 0 &&
    //   (appException == "Yes") &&
    //   (clientInformed == "Yes") && clientImpacted == "No") {
      
    //   Constatus="Risk validation"
    // }
    // else if (AccManage == "Yes" &&
    //   CorApp == "Yes" &&
    //   raisedDateVal > 0 &&
    //   (appException == "" || appException == null) &&
    //   clientInformed == "Yes") {
      
    //   Constatus = "Complete"
    // }
    // else if (AccManage == "Yes" &&
    //   CorApp == "No" &&
    //   appException == "No" &&
    //   clientInformed == "Yes" && (clientImpacted == "Yes" || clientImpacted == "No") && dateCompare < 0) {
      
    //   Constatus = "Date has passed, please provide an update"
    // }

  }
}